import { Button } from '../../Components/UI/button';
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Input } from '../../Components/UI/input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../Components/UI/table';
import { Card, CardContent } from '../../Components/UI/card';
import { Search, Plus, Filter, Loader2, ArrowUp, ArrowDown, MehIcon, Smile, Frown, ArrowDownWideNarrow, UserIcon, ClockFadingIcon, CalendarIcon, ChartPie, MapPin, Download, Activity, ArrowLeft, X, Check, CheckCircle, Phone, Handshake, MoreHorizontal, ChevronDown, Trash2, MessageSquare, Mail, FileText } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { checkIfInqOnlyMode, getThreadTypesArr, getUsersArr, isSmartSellerMode, userIsAdmin } from '../../Store/Reducers';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '../../Components/UI/tooltip';
import { countries, states, defaultIndianCities } from '../../Components/Enums/DataEnums';
import { cn } from "../../Lib/Cn";
import { BsBellFill, BsWhatsapp } from 'react-icons/bs';
import { MdPhone } from 'react-icons/md';
import { currentUserHasPermission, FormatAmount, getCurrentUser, getLastDateColor, getTaskColor, getThreadTypeMeta, getRelativeDateText } from '../../Utils/Utilities';
import { getAuthData } from '../../Utils/AuthUtils';
import { Popover, PopoverTrigger, PopoverContent } from '../../Components/UI/popover';
import { Calendar } from '../../Components/UI/calendar';
import { SpeechControls } from '../../Components/Common/SpeechControls';
import { manageRecordAPI } from '../Records/RecordAPI';
import { saveMastersConfigAPI } from '../Settings/MasterDataAPI';
import { CommonFilter } from '../../Components/Common/CommonFilter';
import Pagination from '../../Components/Common/Pagination';
import { formatAmount, formatDate } from '../../Utils/Utilities';
import { getConfigData } from '../../Utils/Storage';
import { addDays, addMonths, format, isSameDay, parse } from 'date-fns';
import useIsMobile from '../../Hooks/useIsMobile';
import DrawerFilter from '../../Components/Common/DrawerFilter';
import { Drawer, DrawerClose, DrawerContent, DrawerFooter } from '../../Components/UI/drawer';
import { RiResetLeftFill } from 'react-icons/ri';
import ContactActions from '../../Components/Common/ContactActions';
import { useLocation, useNavigate } from 'react-router-dom';
import ConnectionEntryDialog from './ConnectionEntry';
import ImportExcel from './ImportExcel';
import { canShowImportInquiries } from '../../Utils/FeatureFlags';
import { useCurrency } from '../../Hooks/useCurrency';
import ThreadSahiIcon from '../../Components/Common/ThreadSahiIcon';
import { setGlobalLoading } from '../../Store/Actions';
import ConnectionDetailsWrapper from './ConnectionDetailsWrapper';
import { useConnectionFilter } from '../../Hooks/useConnectionFilter';
import { isAgencyAllowed, updateHeaderConfig } from '../../Store/Reducers'
import ColumnPreferencesDropdown from '../../Components/Common/ColumnPrefereceDD';
import { sentimentEmoji } from '../../Utils/Utilities';
import { HoverCard, HoverCardTrigger, HoverCardContent } from '@radix-ui/react-hover-card';
import { manageFdbkRequestAPI } from './ConnectionAPI';
import { toast } from "sonner";
import { AlertBox } from '../../Components/Common/AlertBox';
import { useDesktop } from "../../Components/Common/IsDesktop"
import WspDialog from '../../Components/Common/WspDialog';
import { exportToExcel } from "../../Utils/ExcelExportUtils";
import { FaFileExcel } from 'react-icons/fa6';

import { useDebounce } from '../../Hooks/useDebounce';
import { Checkbox } from '../../Components/UI/checkbox';
import BulkWhatsAppDialog from '../Configs/WhatsAppDirectConfig/BulkWhatsAppDialog';
import { handlePhoneClickAction, handleWhatsAppClickAction } from "../../Utils/ContactLogUtils";
import TemplateDialog from '../../Components/Common/TemplateDialog';

//CSS common classes 
var filterBtn = "button-config sahi-primary-button flex items-center justify-center group px-2.5 py-[5px]";

// Connection type labels with singular names for button text, limited to Customer and Supplier
const connTypeLabels = {
	C: { label: "Customer", singular: "Customer", plural: "Customers", className: "bg-sahi-orange-light text-sahi-orange" },
	S: { label: "Supplier", singular: "Supplier", plural: "Suppliers", className: "bg-sahi-blue-light text-sahi-blue" },
	P: { label: "Prospect", singular: "Prospect", plural: "Prospects", className: "bg-sahi-green-light text-sahi-green" },
	O: { label: "Other", singular: "Other", plural: "Others", className: "bg-zinc-100 text-zinc-700" },
};

const sentimentMap = {
	negative: ['unhappy'],
	positive: ['happy'],
	neutral: ['ok'],
	'': ['unknown', 'all']
};

const mobileSortMap = {
	"Due (oldest first)": { key: "nextTaskDT", direction: "asc" },
	"Received (newest first)": { key: "sinceDT", direction: "desc" },
	"Inactivity period": { key: "activity", direction: "desc" },
	"Business (A-Z)": { key: "bizName", direction: "asc" },
}

// Query string mappings
const statusQueryMap = {
	'A': 'active',
	'I': 'inactive',
	'F': 'future'
};

const statusReverseMap = {
	'active': 'A',
	'inactive': 'I',
	'future': 'F'
};

const lastContactQueryMap = {
	'0': 'None',
	'1': 'Today',
	'2': 'Yesterday',
	'3': 'Last 7 days',
	'4': 'Last 30 days',
	'5': 'Last 3 months',
	'6': 'Last 6 months'
};

const notContactedQueryMap = {
	'1': 'Last 7 days',
	'2': 'Last 30 days',
	'3': 'Last 3 months',
	'4': 'Last 6 months',
	'5': 'More than 6 months'
};

const nextTaskQueryMap = {
	'0': 'Next Action Not Set',
	'1': 'Next Action Overdue',
	'2': 'Next Action Today',
	'3': 'Next Action Tomorrow',
	'4': 'Next Action Next 7 days',
	'5': 'Next Action Next 30 days'
};

const noActivityQueryMap = {
	'0': 'Unknown',
	'1': 'Inactive for last 7 days',
	'2': 'Inactive for last 30 days',
	'3': 'Inactive for last 60 days',
	'4': 'Inactive for last 3 months',
	'5': 'Inactive for last 6 months',
	'6': 'More than 6 months'
};

const lastActivityQueryMap = {
	'1': 'Last 7 days',
	'2': 'Last 30 days',
	'3': 'Last 3 months',
	'4': 'Last 6 months',
	'5': 'More than 6 months'
};

const SentimentIcon = ({ sentiment }) => {
	const normalized = (sentiment || "").toLowerCase();
	switch (normalized) {
		case "positive":
			return <Smile className="text-sahi-green w-[18px] h-[18px] font-extralight align-top relative top-[2px]" />;
		case "neutral":
			return <MehIcon className="text-sahi-orange w-[18px] h-[18px] font-extralight align-top relative top-[2px]" />;
		case "negative":
			return <Frown className="text-sahi-red w-[18px] h-[18px] font-extralight align-top relative top-[2px]" />;
		default:
			return null;
	}
};

const Connections = ({ embedded = false, searchTerm: externalSearchTerm = "", onFilterStateChange, onCountChange }) => {
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch()
	const { data: connectionData, loading, error } = useSelector(state => state.connectionData);
	const { data: threadData } = useSelector((state) => state.threadData);
	const { data: taskData } = useSelector((state) => state.taskData);
	const searchParams = new URLSearchParams(location.search);

	useEffect(() => {
		if (embedded && typeof externalSearchTerm === "string") {
			setSearchTerm(externalSearchTerm);
		}
	}, [embedded, externalSearchTerm]);

	useEffect(() => {
		if (!embedded) return;
		const handleToggle = () => {
			setIsFilterSelected(true);
			setIsDrawerOpen(true);
		};
		window.addEventListener("contacts-toggle-filter", handleToggle);
		return () => {
			window.removeEventListener("contacts-toggle-filter", handleToggle);
		};
	}, [embedded]);

	// Helper function to map old URL params (t, s) to new contactCategory
	const getInitialContactCategory = () => {
		const typeParam = searchParams.get('t')?.toUpperCase();
		const statusParam = searchParams.get('s')?.toUpperCase();

		// Check for no activity (inactive customers) parameter first
		if (searchParams.has('na') || searchParams.has('NA')) {
			return 'InactiveCustomer';
		}

		// Check for cold contacts
		if (searchParams.get('cold') === 'true' || typeParam === 'COLD') {
			return 'cold';
		}

		// Check status parameter first when it disambiguates a type that maps to multiple
		// categories (t=C covers both CurrentCustomer and InactiveCustomer) - must run before
		// the generic type-based check below, otherwise t=c&s=i always resolved to CurrentCustomer.
		if (statusParam === 'I') {
			return 'InactiveCustomer';
		}

		// Map based on connection type parameter
		if (typeParam === 'P') {
			return 'FutureProspect';
		} else if (typeParam === 'C') {
			return 'CurrentCustomer';
		} else if (typeParam === 'S') {
			return 'Supplier';
		} else if (typeParam === 'O') {
			return 'Other';
		}

		// Map based on status parameter
		if (statusParam === 'F') {
			return 'FutureProspect';
		} else if (statusParam === 'A') {
			return 'CurrentCustomer';
		}

		// Default to 'all' if no specific mapping
		return 'all';
	};

	const initialTypeFilter = searchParams.get('t')?.toUpperCase() || 'all';
	const initialStatus = statusQueryMap[searchParams.get('s')?.toUpperCase()] || 'all';
	const initialContactCategory = getInitialContactCategory();
	const initialLastContact = lastContactQueryMap[searchParams.get('lc') || searchParams.get('LC')] || 'all';
	const initialNotContacted = notContactedQueryMap[searchParams.get('nc') || searchParams.get('NC')] || 'all';
	const initialNoActivity = noActivityQueryMap[searchParams.get('na') || searchParams.get('NA')] || 'all';
	const initialLastActivity = lastActivityQueryMap[searchParams.get('la') || searchParams.get('LA')] || 'all';
	const initialNextTask = nextTaskQueryMap[searchParams.get('nt') || searchParams.get('NT')] || 'all';
	const coldParam = searchParams.get('cold');
	const [connections, setConnections] = useState([]);
	const [filteredConnections, setFilteredConnections] = useState([]);
	const [coldConnections, setColdConnections] = useState([]);
	const [searchTerm, setSearchTerm] = useState('');
	const debouncedSearchTerm = useDebounce(searchTerm, 300);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [currentPage, setCurrentPage] = useState(1);
	const [isFilterSelected, setIsFilterSelected] = useState(false);
	const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
	const [openConnectionModal, setOpenConnectionModal] = useState(false);
	const [selectedConnection, setSelectedConnection] = useState(null);
	const [isConnectionDialogOpen, setIsConnectionDialogOpen] = useState(false);
	const canAddConnections = currentUserHasPermission('ConnEntry');
	const isAgencyAuthorized = useSelector(isAgencyAllowed);
	const [showColdContactsOnly, setShowColdContactsOnly] = useState(false);
	const [showNormalContactsOnly, setShowNormalContactsOnly] = useState(false);
	const [selectedFilters, setSelectedFilters] = useState({
		city: 'all',
		state: 'all',
		country: 'all',
		segment: 'all',
		assignedTo: 'all',
		lastContact: initialLastContact,
		notContacted: initialNotContacted,
		nextTask: initialNextTask,
		noActivity: initialNoActivity,
		lastActivity: initialLastActivity,
		sentiment: 'all',
		status: initialStatus,
		t: initialTypeFilter, //connection type
		region: 'all',
		contactCategory: initialContactCategory // NEW: Merged filter for Regular/Cold Contacts with sub-filters
	});
	const [tempFilters, setTempFilters] = useState(selectedFilters);
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const [tempsortConfig, setTempsortConfig] = useState(sortConfig);
	const [activeTab, setActiveTab] = useState("sort");
	const [isDetailOpen, setIsDetailOpen] = useState(false);
	const [isWspDialogOpen, setIsWspDialogOpen] = useState(false);
	const [selectedConnectionForWsp, setSelectedConnectionForWsp] = useState(null);
	const [connTypeInfo, setConnTypeInfo] = useState({ t: 'all', label: 'Contacts', singular: 'Contact' });
	const cities = useSelector(state => state.masterData.cities || []);
	const combinedCities = useMemo(() => {
		const seen = new Set();
		const merged = [];
		cities.forEach(c => {
			const lower = c.toLowerCase().trim();
			if (lower && !seen.has(lower)) {
				seen.add(lower);
				merged.push(c.trim());
			}
		});
		defaultIndianCities.forEach(c => {
			const lower = c.toLowerCase().trim();
			if (lower && !seen.has(lower)) {
				seen.add(lower);
				merged.push(c.trim());
			}
		});
		return merged.sort((a, b) => a.localeCompare(b));
	}, [cities]);
	const EMPTY_ARRAY = useMemo(() => [], []);
	const segments = useSelector(state => state.masterData.segments) || EMPTY_ARRAY;
	const regions = useSelector(state => state.masterData.regions) || EMPTY_ARRAY;
	const prevFiltersRef = useRef({});
	const hasActiveFilters = useMemo(() => {
		return Object.values(selectedFilters).some(value => value !== 'all');
	}, [selectedFilters]);

	useEffect(() => {
		if (embedded && onFilterStateChange) {
			onFilterStateChange(Boolean(hasActiveFilters));
		}
	}, [embedded, hasActiveFilters, onFilterStateChange]);

	const [isInitLoading, setIsInitLoading] = useState(connectionData.length > 0 ? true : false);

	useEffect(() => {
		if (embedded && onCountChange && !loading && !isInitLoading) {
			const hasRawData = connectionData && connectionData.length > 0;
			if (filteredConnections.length === 0 && hasRawData) {
				return;
			}
			const totalAmt = (filteredConnections || []).reduce((sum, item) => sum + (Number(item.potential || item.Potential || 0) || 0), 0);
			onCountChange(filteredConnections.length, totalAmt);
		}
	}, [embedded, filteredConnections, onCountChange, loading, isInitLoading, connectionData]);

	const users = useSelector(getUsersArr);
	const isMobile = useIsMobile();
	const clickedTabRef = useRef(null);
	const [threadCntType, setThreadCntType] = useState("all");
	const threadType = useSelector(getThreadTypesArr);
	const currencySymbol = useCurrency();
	const extraFields = useSelector(state => state.masterData.extraFields) || EMPTY_ARRAY;
	const agencyData = useSelector(state => state.agencyData.data) || EMPTY_ARRAY;
	const connColPrefs = useSelector(state => state.masterData.connColPrefs) || EMPTY_ARRAY;
	const isInqMode = useSelector(checkIfInqOnlyMode);
	const isAdmin = useSelector(userIsAdmin);
	const [activeSentimentFilter, setActiveSentimentFilter] = useState(null);
	const isIndia = agencyData.CountryID === 1;
	const canEditConnections = currentUserHasPermission('ConnEdit');
	const canDeleteConnections = currentUserHasPermission('ConnDel');
	const canCreateConnections = currentUserHasPermission('ConnEntry');
	const currentUser = getCurrentUser();
	const dfltFdbkReqObj = {
		openDialog: false,
		connID: 0,
		connMobile: '',
		connCC: '',
		connBizName: '',
		connContactName: '',
		connEmail: ''
	};
	const [fdbkReqState, setFdbkReqState] = useState(dfltFdbkReqObj);
	const isDesktop = useDesktop();
	const [selectedConnIDs, setSelectedConnIDs] = useState([]);
	const [selectAllCurrentPage, setSelectAllCurrentPage] = useState(false);
	const [bulkWhatsAppDialogOpen, setBulkWhatsAppDialogOpen] = useState(false);
	const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
	const [templateDialogData, setTemplateDialogData] = useState([]);
	const [isTemplateDialogActive, setIsTemplateDialogActive] = useState(false);

	const [isBulkAllowed, setIsBulkAllowed] = useState(false);
	const [expandedConnID, setExpandedConnID] = useState(null);
	const [openRecordTypeDropdown, setOpenRecordTypeDropdown] = useState(false);
	const [recordTypeView, setRecordTypeView] = useState('list'); // 'list' | 'add'
	const [newRecordTypeName, setNewRecordTypeName] = useState('');
	const [recordTypeSearch, setRecordTypeSearch] = useState('');
	const [isSavingRecordType, setIsSavingRecordType] = useState(false);
	const [recordTypeToDelete, setRecordTypeToDelete] = useState(null);
	const [deleteRecordTypeAlertOpen, setDeleteRecordTypeAlertOpen] = useState(false);
	const recordTypesData = useSelector((state) => state.masterData?.recordTypes || []);
	const sortedRecordTypes = useMemo(() => {
		const types = [...(recordTypesData || [])];
		return types.sort((a, b) => (a.Typ || '').localeCompare(b.Typ || '', undefined, { sensitivity: 'base' }));
	}, [recordTypesData]);
	const [quickRecordData, setQuickRecordData] = useState({
		notes: '',
		recordType: 'Call',
		recordDate: format(new Date(), 'dd-MMM-yy'),
		pocUserID: ''
	});
	const [datePickerConnID, setDatePickerConnID] = useState(null);
	const [isSavingQuickRecord, setIsSavingQuickRecord] = useState(false);

	const handleAddRecordType = async () => {
		const trimmed = newRecordTypeName.trim();
		if (!trimmed) return;
		const isDup = sortedRecordTypes.some(t => (t.Typ || '').toLowerCase() === trimmed.toLowerCase());
		if (isDup) {
			toast.error('An interaction type with this name already exists.');
			return;
		}
		setIsSavingRecordType(true);
		try {
			const res = await saveMastersConfigAPI('recordTypes', 'add', { typ: trimmed, isInxn: true, hasGeo: false });
			if (!res.error) {
				toast.success('Interaction type added successfully.');
				setQuickRecordData(prev => ({ ...prev, recordType: trimmed }));
				setNewRecordTypeName('');
				setRecordTypeView('list');
				setOpenRecordTypeDropdown(false);
			} else {
				toast.error(res.message || 'Failed to add interaction type.');
			}
		} catch (err) {
			console.error('Error adding record type:', err);
			toast.error('Failed to add interaction type.');
		} finally {
			setIsSavingRecordType(false);
		}
	};

	const handleDeleteRecordType = async () => {
		if (!recordTypeToDelete) return;
		setIsSavingRecordType(true);
		try {
			const res = await saveMastersConfigAPI('recordTypes', 'delete', recordTypeToDelete.Typ);
			if (!res.error) {
				toast.success('Interaction type deleted.');
				if (quickRecordData.recordType === recordTypeToDelete.Typ) {
					setQuickRecordData(prev => ({ ...prev, recordType: 'Call' }));
				}
				setDeleteRecordTypeAlertOpen(false);
				setRecordTypeToDelete(null);
			} else {
				toast.error(res.message || 'Failed to delete interaction type.');
			}
		} catch (err) {
			console.error('Error deleting record type:', err);
			toast.error('Failed to delete interaction type.');
		} finally {
			setIsSavingRecordType(false);
		}
	};

	const handleToggleQuickInteraction = (connection) => {
		if (expandedConnID === connection.connID) {
			setExpandedConnID(null);
		} else {
			const authData = getAuthData();
			const currentUserID = authData?.UserID || currentUser?.UserID || (users && users[0]?.userID) || '';
			setQuickRecordData({
				notes: '',
				recordType: 'Call',
				recordDate: format(new Date(), 'dd-MMM-yy'),
				pocUserID: currentUserID
			});
			setExpandedConnID(connection.connID);
		}
	};

	const handleSaveQuickRecord = async (connection) => {
		if (!quickRecordData.notes || quickRecordData.notes.trim() === '') {
			toast.error("Please enter notes for this record.");
			return;
		}

		setIsSavingQuickRecord(true);
		try {
			let dateStr = quickRecordData.recordDate || format(new Date(), "dd-MMM-yy");
			const parts = dateStr.split("-");
			if (parts.length === 3 && parts[2].length === 2) {
				parts[2] = "20" + parts[2];
				dateStr = parts.join("-");
			}
			const defaultTime = format(new Date(), "HH:mm");
			let parsedDate = new Date(dateStr + " " + defaultTime);
			if (isNaN(parsedDate.getTime())) {
				parsedDate = new Date();
			}

			const authData = getAuthData();
			const formattedRecordData = {
				connID: connection.connID || 0,
				pocUserID: quickRecordData.pocUserID || authData?.UserID || currentUser?.UserID || 0,
				recType: quickRecordData.recordType || "Call",
				recDT: parsedDate.toISOString(),
				recNotes: quickRecordData.notes.trim(),
				recThreadIDs: "",
				recContractIDs: "",
				recLat: "",
				recLon: "",
				currStageID: 1,
				reason: ""
			};

			const result = await manageRecordAPI(formattedRecordData, null, 'ADD', 0);
			if (!result.error) {
				toast.success("Record added successfully.");
				setExpandedConnID(null);
				setQuickRecordData({
					notes: '',
					recordType: 'Call',
					recordDate: format(new Date(), 'dd-MMM-yy'),
					pocUserID: authData?.UserID || currentUser?.UserID || ''
				});
				// Use the record's own date (recDT) — not "now" — so a backdated interaction
				// shows the correct "Last" immediately instead of today's date.
				const recIso = parsedDate.toISOString();
				const recFormatted = format(parsedDate, "dd-MMM-yy");
				setConnections(prev => prev.map(c => c.connID === connection.connID ? {
					...c,
					lastRecDT: recIso,
					lastRecDTF: recFormatted
				} : c));
				setFilteredConnections(prev => prev.map(c => c.connID === connection.connID ? {
					...c,
					lastRecDT: recIso,
					lastRecDTF: recFormatted
				} : c));
			} else {
				toast.error(result.message || "Failed to save record.");
			}
		} catch (err) {
			toast.error(err.message || "Something went wrong while saving the record.");
			console.error("Error saving quick record:", err);
		} finally {
			setIsSavingQuickRecord(false);
		}
	};

	// Memoized data of selected connections to pass to the dialog
	const selectedConnectionsData = useMemo(() => {
		return filteredConnections.filter(c => selectedConnIDs.includes(c.connID));
	}, [selectedConnIDs, filteredConnections]);

	// Handle either it is admin or normal user
	const columnDfltVisibilityObj = {
		bizName: true,
		contactName: true,
		potential: true,
		activity: true,
		sinceDT: true,
		lastRecDT: true,
		nextTaskDT: true,
		pocUserID: true,
		regionID: true,
		taxID: false,
		source: false,
		city: false,
		state: false,
		country: false,
		mobile: false,
		email: false,
		feedback: false,
		segment: false,
		tags: false
	};

	// Function to get column visibility from preferences
	const getColumnVisibilityFromPrefs = (prefs) => {
		if (!prefs || (Array.isArray(prefs) && prefs.length === 0)) {
			return { ...columnDfltVisibilityObj };
		}

		// If it's an array, get the first element
		const prefsData = Array.isArray(prefs) ? prefs[0] : prefs;

		// If it's a string, parse it
		let parsedPrefs = prefsData;
		if (typeof prefsData === 'string') {
			try {
				parsedPrefs = JSON.parse(prefsData);
				// If parsing gives an array, get first element
				if (Array.isArray(parsedPrefs)) {
					parsedPrefs = parsedPrefs[0];
				}
			} catch (error) {
				console.error("Error parsing preferences:", error);
				return { ...columnDfltVisibilityObj };
			}
		}

		return {
			bizName: parsedPrefs.BizName ?? true,
			contactName: parsedPrefs.ContactName ?? true,
			potential: parsedPrefs.Potential ?? true,
			activity: parsedPrefs.Activity ?? true,
			sinceDT: parsedPrefs.SinceDT ?? true,
			lastRecDT: parsedPrefs.LastRecDT ?? true,
			nextTaskDT: parsedPrefs.NextTaskDT ?? true,
			pocUserID: parsedPrefs.POCUser ?? true,
			regionID: parsedPrefs.Region ?? true,
			taxID: parsedPrefs.TaxID ?? false,
			source: parsedPrefs.Source ?? false,
			city: parsedPrefs.City ?? false,
			state: parsedPrefs.State ?? false,
			country: parsedPrefs.Country ?? false,
			mobile: parsedPrefs.Mobile ?? false,
			email: parsedPrefs.Email ?? false,
			feedback: parsedPrefs.Feedback ?? false,
			segment: parsedPrefs.Segment ?? false,
			tags: parsedPrefs.Tags ?? false
		};
	};

	useEffect(() => {
		let isAllowed = false;

		try {
			const record = getConfigData();
			isAllowed = !!record?.WDPreferred?.trim();
		} catch (err) {
			console.error("Failed to parse C cookie", err);
		}

		setIsBulkAllowed(isAllowed);
	}, []);
	useEffect(() => {
		const params = new URLSearchParams(location.search);

		// Check if the 'na' parameter exists at all (any value)
		const hasNoActivityFilter = params.has('na') || params.has('NA');

		if (hasNoActivityFilter) {
			document.title = "Lost Customer";
		} else {
			document.title = "SahiClub";
		}

		// Cleanup: Reset to default title when user leaves this page
		return () => {
			document.title = "SahiClub";
		};
	}, [location.search]);

	// Handle 'cold' parameter from URL (when navigated from InqDashboard, or from the mobile
	// filter drawer's Apply button, which writes cold=true to match getInitialContactCategory)
	useEffect(() => {
		if (coldParam === '1' || coldParam === 'true') {
			setShowColdContactsOnly(true);
		} else {
			setShowColdContactsOnly(false);
		}
	}, [coldParam, location.search]);

	// Monitor showColdContactsOnly state changes
	useEffect(() => {
	}, [showColdContactsOnly]);

	// Get initial column visibility - DON'T use lazy initialization here
	const getInitialColumnVisibility = () => {
		if (isAdmin) {
			return getColumnVisibilityFromPrefs(connColPrefs);
		} else {
			const storedPrefs = localStorage.getItem("ConnColPrefs");
			if (storedPrefs) {
				try {
					const parsed = JSON.parse(storedPrefs);
					return {
						bizName: parsed.bizName ?? true,
						contactName: parsed.contactName ?? true,
						potential: parsed.potential ?? true,
						activity: parsed.activity ?? true,
						sinceDT: parsed.sinceDT ?? true,
						lastRecDT: parsed.lastRecDT ?? true,
						nextTaskDT: parsed.nextTaskDT ?? true,
						pocUserID: parsed.pocUserID ?? true,
						regionID: parsed.regionID ?? true,
						taxID: parsed.taxID ?? false,
						source: parsed.source ?? false,
						city: parsed.city ?? false,
						state: parsed.state ?? false,
						country: parsed.country ?? false,
						mobile: parsed.mobile ?? false,
						email: parsed.email ?? false,
						feedback: parsed.feedback ?? false,
						segment: parsed.Segment ?? false,
						tags: parsed.Tags ?? false
					};
				} catch (error) {
					console.error("Error parsing ConnColPrefs:", error);
				}
			} else {
				try {
					localStorage.setItem("ConnColPrefs", JSON.stringify(getColumnVisibilityFromPrefs(connColPrefs)))
				} catch (error) {
					console.error("Error setting ConnColPrefs:", error);
				}
			}
		}
		return { ...columnDfltVisibilityObj };
	};

	const [columnVisibility, setColumnVisibility] = useState(getInitialColumnVisibility());
	const [columnPrefsHideChks, setColumnPrefsHideChks] = useState([]);

	useEffect(() => {
		if (isAdmin && connColPrefs) {
			const newVisibility = getColumnVisibilityFromPrefs(connColPrefs);

			// Use JSON.stringify for deep comparison to avoid false positives
			const currentStr = JSON.stringify(columnVisibility);
			const newStr = JSON.stringify(newVisibility);

			if (currentStr !== newStr) {
				setColumnVisibility(newVisibility);
			}
		}

		// Set hide checkboxes for region if no regions exist
		if (regions.length === 0) {
			setColumnPrefsHideChks(['regionID']);
		} else {
			setColumnPrefsHideChks([]);
		}
	}, [connColPrefs, isAdmin, regions.length]);

	useEffect(() => {
		if (!isAdmin) {
			const handleStorageChange = (e) => {
				if (e.key === 'ConnColPrefs' && e.newValue) {
					try {
						const parsed = JSON.parse(e.newValue);
						const newVisibility = {
							bizName: parsed.bizName ?? true,
							contactName: parsed.contactName ?? true,
							potential: parsed.potential ?? true,
							activity: parsed.activity ?? true,
							sinceDT: parsed.sinceDT ?? true,
							lastRecDT: parsed.lastRecDT ?? true,
							nextTaskDT: parsed.nextTaskDT ?? true,
							pocUserID: parsed.pocUserID ?? true,
							regionID: parsed.regionID ?? true,
							taxID: parsed.taxID ?? false,
							source: parsed.source ?? false,
							city: parsed.city ?? false,
							state: parsed.state ?? false,
							country: parsed.country ?? false,
							mobile: parsed.mobile ?? false,
							email: parsed.email ?? false,
							feedback: parsed.feedback ?? false,
							segment: parsed.segment ?? false,
							tags: parsed.tags ?? false
						};
						setColumnVisibility(newVisibility);
					} catch (error) {
						console.error("Error parsing ConnColPrefs from storage event:", error);
					}
				}
			};

			// Also check on component mount/focus
			const checkLocalStorage = () => {
				const storedPrefs = localStorage.getItem("ConnColPrefs");
				if (storedPrefs) {
					try {
						const parsed = JSON.parse(storedPrefs);
						const newVisibility = {
							bizName: parsed.bizName ?? true,
							contactName: parsed.contactName ?? true,
							potential: parsed.potential ?? true,
							activity: parsed.activity ?? true,
							sinceDT: parsed.sinceDT ?? true,
							lastRecDT: parsed.lastRecDT ?? true,
							nextTaskDT: parsed.nextTaskDT ?? true,
							pocUserID: parsed.pocUserID ?? true,
							regionID: parsed.regionID ?? true,
							taxID: parsed.taxID ?? false,
							source: parsed.source ?? false,
							city: parsed.city ?? false,
							state: parsed.state ?? false,
							country: parsed.country ?? false,
							mobile: parsed.mobile ?? false,
							email: parsed.email ?? false,
							feedback: parsed.feedback ?? false,
							segment: parsed.segment ?? false,
							tags: parsed.tags ?? false
						};

						// Use JSON.stringify for deep comparison
						const currentStr = JSON.stringify(columnVisibility);
						const newStr = JSON.stringify(newVisibility);

						if (currentStr !== newStr) {
							setColumnVisibility(newVisibility);
						}
					} catch (error) {
						console.error("Error parsing ConnColPrefs:", error);
					}
				}
			};

			// Check immediately on mount (run once)
			checkLocalStorage();

			// Listen for storage changes from other tabs/windows
			window.addEventListener('storage', handleStorageChange);
			// Check when window gains focus (user navigates back)
			window.addEventListener('focus', checkLocalStorage);

			return () => {
				window.removeEventListener('storage', handleStorageChange);
				window.removeEventListener('focus', checkLocalStorage);
			};
		}

		// Set hide checkboxes for region if no regions exist
		if (regions.length === 0) {
			setColumnPrefsHideChks(['regionID']);
		} else {
			setColumnPrefsHideChks([]);
		}
	}, [isAdmin, regions.length]);

	const resetSelection = useCallback(() => {
		setSelectedConnIDs([]);
		setSelectAllCurrentPage(false);
	}, []);

	useEffect(() => {
		resetSelection();
	}, [
		selectedFilters,
		debouncedSearchTerm,
		activeSentimentFilter
	]);

	useEffect(() => {
		if (regions.length === 0) {
			setColumnVisibility((prev) => {
				// Only update if regionID is currently true
				if (prev.regionID !== false) {
					return { ...prev, regionID: false };
				}
				return prev; // No change needed, prevent re-render
			});
		}
	}, [regions.length]);

	const sentimentCounts = useMemo(() => {
		// Only calculate for Customer type or All Contacts
		const shouldShow = selectedFilters.sentiment || selectedFilters.contactCategory === 'CurrentCustomer';

		if (!shouldShow) {
			return { happy: 0, unhappy: 0, unknown: 0 };
		}

		const counts = { happy: 0, unhappy: 0, unknown: 0 };

		filteredConnections.forEach(connection => {
			// Only count if connection is a customer (has 'C' in connTypes)
			if (!connection.connTypes || !connection.connTypes.includes('C')) {
				return;
			}
			const score = connection.fdbkScore;

			if (score >= 4 && score <= 5) {
				counts.happy++;
			} else if (score >= 1 && score < 4) {
				counts.unhappy++;
			} else {
				counts.unknown++;
			}
		});

		return counts;
	}, [connections, selectedFilters.contactCategory, filteredConnections]);

	const segmentsWithColors = useMemo(() => { return segments?.map(seg => ({ CNm: seg.CNm, Clr: `#${seg.Clr}` })) || []; }, [segments]);
	useEffect(() => {
		const searchParams = new URLSearchParams(location.search);
		const openImport = searchParams.get('openImport');

		if (openImport === 'true') {
			setOpenConnectionModal(true); // or whatever your connection import modal state is
			// Clean up URL
			searchParams.delete('openImport');
			navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
		}

		// Note: showColdContactsOnly is now handled by its own dedicated useEffect below
	}, [location.search]);
	const connectionTypeOptions = isInqMode
		? [
			{ name: "Customers", ID: "C" },
			{ name: "Prospects", ID: "P" }
		]
		: [
			{ name: "Customers", ID: "C" },
			{ name: "Suppliers", ID: "S" }
		];

	// filterOptions - the filter options for the filter drawer
	const filterOptions = [
		{
			key: 'contactCategory',
			label: 'All Contacts',
			type: 'list',
			searchEnabled: false,
			mobileDropdownText: "Contact Type",
			MobileLabel: "Contact Type",
			showAllOption: true,
			categories: [
				{
					name: 'Regular Contacts',
					value: 'regular',
					subFilters: [
						{ name: 'Prospects', value: 'FutureProspect', displayValue: 'Prospects' },
						{ name: 'Current Customers', value: 'CurrentCustomer', displayValue: 'Current Customers' },
						{ name: 'Inactive Customers', value: 'InactiveCustomer', displayValue: 'Inactive Customers' },
						{ name: 'Suppliers', value: 'Supplier', displayValue: 'Suppliers' },
						{ name: 'Others', value: 'Other', displayValue: 'Others' }
					]
				},
				{
					name: 'Cold Contacts',
					value: 'cold',
					subFilters: []
				}
			],
			displayValue: (val) => {
				// Map the filter value back to display text
				const filterMap = {
					'all': 'All Contacts',
					'FutureProspect': 'Prospects',
					'CurrentCustomer': 'Current Customers',
					'InactiveCustomer': 'Inactive Customers',
					'Supplier': 'Suppliers',
					'Other': 'Others',
					'cold': 'Cold Contacts'
				};
				return filterMap[val] || 'All Contacts';
			}
		},
		...(!isSmartSellerMode() ? [{
			key: "assignedTo", label: "All Executives",
			options: [{ name: "Not Assigned", ID: "unassigned" }, ...users.map((u) => ({ name: u.name, ID: u.userID })),],
			displayValue: (val) => {
				if (val === "unassigned") return "Not Assigned";
				return users.find((u) => u.userID === val)?.name || "All Executives";
			},
			type: "list",
			mobileDropdownText: "Select Executive",
			MobileLabel: "Executive",
			showAllOption: true
		}] : []),

		{
			key: 'country',
			label: 'All Countries',
			options: countries.map(c => c.Country),
			type: 'list',
			searchEnabled: true,
			mobileDropdownText: "Select Country",
			MobileLabel: "Location",
			showAllOption: true,
			allText: "All Countries",
		},
		{
			key: 'state',
			label: 'All States',
			options: states.map(s => s.State),
			type: 'list',
			searchEnabled: true,
			mobileDropdownText: "Select State",
			disabled: !(tempFilters.country === "India"),
			mobileNoLabel: true,
			showAllOption: true,
			allText: "All States",
		},
		{
			key: 'city',
			label: 'All Cities',
			options: combinedCities,
			type: 'list',
			searchEnabled: true,
			mobileDropdownText: "Select City",
			mobileNoLabel: true,
			showAllOption: true,
			allText: "All Cities",
		},
		{
			key: 'segment',
			label: 'All Categories',
			options: segments.map((seg) => (seg)),
			type: "list",
			mobileDropdownText: "Select Categories",
			MobileLabel: "Category",
			showAllOption: true,
			// NEW: Add renderOption to show colored dots
			renderOption: (option) => (
				<>
					{option.Clr && (
						<div
							className="w-2.5 h-2.5 rounded-full flex-shrink-0"
							style={{ backgroundColor: `#${option.Clr}` }}
						/>
					)}
					<span>{option.CNm}</span>
				</>
			)
		},
		{
			key: 'region',
			label: 'All Regions',
			options: regions.map(rgn => ({ ID: rgn.RID, name: rgn.Rgn })),
			displayValue: (val) => {
				return regions.find((r) => r.RID === val)?.Rgn || val;
			},
			type: "list",
			searchEnabled: false,
			mobileDropdownText: "Select Region",
			MobileLabel: "Region",
			showAllOption: true
		},
		{
			key: 'sentiment',
			label: 'All Sentiments',
			options: ['Unknown', 'Unhappy', 'Ok', 'Happy'],
			type: "options",
			searchEnabled: false,
			MobileLabel: "Sentiment",
			showAllOption: true
		},
		/* {
			key: 'lastContact',
			label: 'Last Contacted',
			options: ['None', 'Yesterday', 'Today', 'Last 7 days', 'Last 30 days', 'Last 3 months', 'Last 6 months'],
			type: "options",
			searchEnabled: false,
			MobileLabel: "Last Contacted",
			showAllOption: true
		},
		{
			key: 'notContacted',
			label: 'Not Contacted',
			options: ['Last 7 days', 'Last 30 days', 'Last 3 months', 'Last 6 months', 'More than 6 months'],
			type: "options",
			searchEnabled: false,
			MobileLabel: "Not Contacted",
			showAllOption: true
		},
		
		{
			key: 'lastActivity',
			label: 'Last Activity',
			options: ['Last 7 days', 'Last 30 days', 'Last 3 months', 'Last 6 months', 'More than 6 months'],
			type: "options",
			searchEnabled: false,
			MobileLabel: "Last Activity",
			showAllOption: true
		}, */
		{
			key: 'nextTask',
			label: 'All Next Actions',
			options: ['Next Action Not Set', 'Next Action Overdue', 'Next Action Today', 'Next Action Tomorrow', 'Next Action Next 7 days', 'Next Action Next 30 days'],
			type: "options",
			searchEnabled: false,
			MobileLabel: "All Next Actions",
			showAllOption: true
		},
		{
			key: 'noActivity',
			label: 'All Activity',
			options: ['Unknown', 'Inactive for last 7 days', 'Inactive for last 30 days', 'Inactive for last 3 months', 'Inactive for last 6 months', 'More than 6 months'],
			type: "options",
			searchEnabled: false,
			MobileLabel: "All Activity",
			showAllOption: true
		},
		{ key: 'sort', label: 'Sort by', options: ['Due (oldest first)', 'Received (newest first)', 'Inactivity period', 'Business (A-Z)'], type: 'sort', mobileOnly: true }
	]

	useEffect(() => {
		const statusParam = statusQueryMap[searchParams.get('s')?.toUpperCase()] || 'all';
		const lastContactParam = lastContactQueryMap[searchParams.get('lc') || searchParams.get('LC')] || 'all';
		const typeParam = searchParams.get('t')?.toUpperCase() || 'all';
		const notContactedParam = notContactedQueryMap[searchParams.get('nc') || searchParams.get('NC')] || 'all';
		const noActivityParam = noActivityQueryMap[searchParams.get('na') || searchParams.get('NA')] || 'all';
		const lastActivityParam = lastActivityQueryMap[searchParams.get('la') || searchParams.get('LA')] || 'all';
		const nextTaskParam = nextTaskQueryMap[searchParams.get('nt') || searchParams.get('NT')] || 'all';

		// Map old URL params to contactCategory
		const contactCategoryParam = getInitialContactCategory();

		setSelectedFilters(prev => ({
			...prev,
			status: statusParam,
			lastContact: lastContactParam,
			t: typeParam,
			notContacted: notContactedParam,
			noActivity: noActivityParam,
			lastActivity: lastActivityParam,
			nextTask: nextTaskParam,
			contactCategory: contactCategoryParam
		}));

		// Note: showColdContactsOnly is now handled ONLY by the dedicated useEffect above (line ~418)
		// Remove this to avoid conflicts with that effect

		if (!isMobile) {
			if (statusParam !== "all" || lastContactParam !== "all" || typeParam !== "all" ||
				notContactedParam !== "all" || noActivityParam !== "all" || lastActivityParam !== "all" ||
				nextTaskParam !== "all" || coldParam === '1') {
				setIsFilterSelected(true)
			}
		}
	}, [location.search]);

	useEffect(() => {
		const categoryVal = selectedFilters.contactCategory;
		const lastContactVal = selectedFilters.lastContact;
		const notContactedVal = selectedFilters.notContacted;
		const noActivityVal = selectedFilters.noActivity;
		const lastActivityVal = selectedFilters.lastActivity;
		const nextTaskVal = selectedFilters.nextTask;

		// Map category back to connection type for connTypeInfo
		const categoryToTypeMap = {
			'FutureProspect': 'P',
			'CurrentCustomer': 'C',
			'InactiveCustomer': 'C',
			'cold': 'all',
			'regular': 'all'
		};

		const connType = categoryToTypeMap[categoryVal] || 'all';

		// update connection type info
		setConnTypeInfo({
			t: connType,
			label: categoryVal === "all" ? "Contacts" : (categoryVal === 'cold' ? 'Cold Contacts' : (categoryVal === 'FutureProspect' ? 'Future Prospects' : (categoryVal === 'CurrentCustomer' ? 'Current Customers' : 'Inactive Customers'))),
			singular: categoryVal === "all" ? "Contact" : "Contact",
		});

		// URL update logic can remain as-is, or can be simplified since we're using a merged filter
		// For now, keeping URL updates to maintain backward compatibility
	}, [selectedFilters.contactCategory, selectedFilters.lastContact, selectedFilters.notContacted,
	selectedFilters.noActivity, selectedFilters.lastActivity, selectedFilters.nextTask, location.pathname, navigate]);

	// Update threadCntType based on contactCategory filter
	useEffect(() => {
		const categoryVal = selectedFilters.contactCategory;

		// Map category to thread type
		if (categoryVal === 'FutureProspect' || categoryVal === 'CurrentCustomer' || categoryVal === 'InactiveCustomer') {
			setThreadCntType("customer");
		} else if (categoryVal === 'cold') {
			setThreadCntType("all");
		} else {
			setThreadCntType("all");
		}
	}, [selectedFilters.contactCategory]);

	// Clean up na/NA URL query parameters when contactCategory is changed to anything other than InactiveCustomer
	useEffect(() => {
		if (selectedFilters.contactCategory !== 'InactiveCustomer') {
			const params = new URLSearchParams(location.search);
			if (params.has('na') || params.has('NA')) {
				params.delete('na');
				params.delete('NA');
				navigate(`${location.pathname}?${params.toString()}`, { replace: true });
			}
		}
	}, [selectedFilters.contactCategory, location.search, navigate]);

	useEffect(() => {
		const categoryVal = selectedFilters.contactCategory;
		// If contactCategory is 'cold' OR if URL has cold=1 parameter, show cold contacts
		if (categoryVal === 'cold' || coldParam === '1') {
			setShowColdContactsOnly(true);
			setShowNormalContactsOnly(false);
		} else {
			setShowColdContactsOnly(false);
			if (categoryVal === 'all' || categoryVal === 'regular' || categoryVal === 'FutureProspect' || categoryVal === 'CurrentCustomer' || categoryVal === 'InactiveCustomer') {
				setShowNormalContactsOnly(true);
			}
		}
	}, [selectedFilters.contactCategory, coldParam]);

	// function to render filter button
	const filterButton = useMemo(() => {
		let activeFilterClass = isFilterSelected && !isMobile ? "filter-active" : "";
		let filterIconToggleClass = "h-4 w-4 " + isMobile ? "" : (isFilterSelected ? "text-sahi-primary-color" : "text-white group-hover:text-sahi-primary-color");
		return (
			<Button
				className={cn(filterBtn, activeFilterClass, "relative")}
				onClick={() => setIsFilterSelected(!isFilterSelected)}
				aria-label="Toggle Filter"
			>
				<div className="h-6 w-6 flex items-center justify-center transition-all">
					<Filter
						className={cn(filterIconToggleClass)}
					/>
				</div>
				{hasActiveFilters && isMobile && (
					<span className="absolute -top-1 -right-1 h-2.5 w-2.5 bg-sahi-green rounded-full border border-sahi-white" />
				)}
			</Button>
		)
	}, [isFilterSelected, isMobile, hasActiveFilters]);

	// getDynamicThreadCol - get the dynamic thread column based on the thread count type
	const getDynamicThreadCol = () => {
		let commonClassName = "!text-right align-middle !flex-row !justify-end cursor-pointer !pr-0";

		switch (threadCntType) {
			case "all":
				return [{
					key: "activity",
					label: "Activity",
					className: cn(commonClassName),
				}];

			case "customer":
				// Filter thread types with 'In' flow for customers
				const customerThreadTypes = threadType.filter(tt => tt.Flow === 'In');
				return customerThreadTypes.map(tt => {
					return {
						key: `cntIn${tt.Sn}Open`,
						label: (
							<ThreadSahiIcon tID={tt.TID} className="h-5 w-5" />
						),
						className: commonClassName,
						style: { color: "var(--sahi-green)" }
					};
				});

			case "supplier":
				// Filter thread types with 'Out' flow for suppliers
				const supplierThreadTypes = threadType.filter(tt => tt.Flow === 'Out');
				return supplierThreadTypes.map(tt => {
					return {
						key: `cntOut${tt.Sn}Open`,
						label: (
							<ThreadSahiIcon tID={tt.TID} className="h-5 w-5" />
						),
						className: commonClassName,
						style: { color: "var(--sahi-orange)" }
					};
				});

			default:
				return [];
		}
	};

	const dynamicThreadCol = getDynamicThreadCol();

	// Helper function to parse custom fields
	const parseCustomFields = (customFieldsString) => {
		if (!customFieldsString || customFieldsString.trim() === '') return [];
		try {
			return JSON.parse(customFieldsString);
		} catch (error) {
			console.error("Error parsing custom fields:", error);
			return [];
		}
	};

	// Helper function to get all unique custom field keys from connections
	const getCustomFieldColumns = () => {

		if (!extraFields || extraFields.length === 0) {
			return [];
		}

		const fieldMap = new Map();

		connections.forEach(connection => {
			const customFields = parseCustomFields(connection.CustomFields);
			customFields.forEach(field => {
				// Only include fields that are configured in master data
				if (field.F && extraFields.includes(field.F) && !fieldMap.has(field.F)) {
					fieldMap.set(field.F, {
						key: `customField_${field.F}`,
						label: field.F,
						className: 'align-middle text-center min-w-[80px]'
					});
				}
			});
		});

		return Array.from(fieldMap.values());
	};
	const customFieldColumns = getCustomFieldColumns();

	const baseTableHeaderCols = [
		{ key: 'bizName', label: 'Business', className: 'align-middle min-w-[220px]' },
		{ key: 'contactName', label: 'Contact', className: 'align-middle' },
		{ key: 'feedback', label: 'Sentiment', className: 'align-middle' },
		{ key: 'mobile', label: 'Mobile', className: 'align-middle' },
		{ key: 'email', label: 'Email', className: 'align-middle' },
		{ key: 'city', label: 'City', className: 'align-middle' },
		{ key: 'state', label: 'State', className: 'align-middle' },
		{ key: 'country', label: 'Country', className: 'align-middle' },
		{ key: 'segment', label: 'Category', className: 'align-middle' },
		{ key: 'source', label: 'Source', className: 'align-middle' },
		{ key: 'potential', label: `Potential (${currencySymbol})`, className: 'align-middle' },
		{ key: 'sinceDT', label: 'Since', className: 'pl-2 .move-sincedt align-middle' },
		{ key: 'lastRecDT', label: 'Last Talk', className: 'align-middle' },
		{ key: 'nextTaskDT', label: 'Next Action', className: 'align-middle' },
		{ key: 'tags', label: 'Tags', className: 'align-middle' },
		{ key: 'pocUserID', label: 'Executive', className: 'align-middle' },
		{ key: 'taxID', label: `${isIndia ? 'GSTIN' : 'Tax ID'}`, className: 'align-middle' },
		{ key: 'regionID', label: 'Region', className: 'align-middle' },
	];

	// Complete columns including dynamic ones (for table rendering)
	const tableHeaderCols = useMemo(
		() => [
			...baseTableHeaderCols,
			...(isInqMode ? [] : dynamicThreadCol),
			...customFieldColumns,
		],
		[baseTableHeaderCols, dynamicThreadCol, customFieldColumns, isInqMode, currencySymbol, isIndia]
	);

	const handleCheckboxChange = (connID) => {
		setSelectedConnIDs(prev =>
			prev.includes(connID)
				? prev.filter(id => id !== connID)
				: [...prev, connID]
		);
	};

	const handleSelectAll = () => {
		if (selectAllCurrentPage) {
			setSelectedConnIDs([]);
		} else {
			const currentPageIDs = currentConnections.map(c => c.connID);
			setSelectedConnIDs(currentPageIDs);
		}
		setSelectAllCurrentPage(!selectAllCurrentPage);
	};

	const handleClearSelection = () => {
		setSelectedConnIDs([]);
		setSelectAllCurrentPage(false);
	};


	//click icon fun for mobile filters
	const handleFilterIconClick = (key) => {
		setActiveTab(key);
		clickedTabRef.current = true;
		setTimeout(() => {
			clickedTabRef.current = false;
		}, 500);
		const el = document.getElementById(key);
		if (el) {
			el.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	};

	useEffect(() => {
		setIsDrawerOpen(true);
		setTempFilters(selectedFilters);
	}, [isFilterSelected, selectedFilters]);

	useEffect(() => {

		if (isTemplateDialogActive) return;

		applyFilters();
	}, [selectedFilters, searchTerm, activeSentimentFilter, debouncedSearchTerm, showColdContactsOnly, showNormalContactsOnly, threadType, coldConnections]);

	useEffect(() => {
		const tType = selectedFilters.t;
		// If the type is not Customer and sentiment filter is active, clear it
		if (!tType.includes('C') && activeSentimentFilter !== null) {
			setActiveSentimentFilter(null);
		}
	}, [selectedFilters.t]);

	const safeParseArray = (input, fallback = []) => {
		if (Array.isArray(input)) return input;
		try {
			return JSON.parse(input || "[]");
		} catch {
			return fallback;
		}
	};

	// Helper function to get executive name by user ID
	const getExecutiveName = (userID) => {
		if (!userID) return '-';
		const user = users.find(user => user.userID === Number(userID));
		return user ? user.name : "";
	};
	// Use the connection filter hook to apply permission-based filtering
	const { filteredConnections: permissionFilteredConnections } = useConnectionFilter(connectionData, {
		connectionTypeFilter: null,
		includeAddOption: false
	});

	useEffect(() => {
		if (isTemplateDialogActive) return;

		dispatch(setGlobalLoading(true));
		if (!Array.isArray(permissionFilteredConnections)) {
			setConnections([]);
			setFilteredConnections([]);
			setColdConnections([]);
			return;
		}

		const processed = permissionFilteredConnections.map((item) => {
			const parsedTasks = safeParseArray(item.Tasks);
			const cntTypewiseThreads = safeParseArray(item.CntTypewiseThreads);
			const cntTypewiseXns = safeParseArray(item.CntTypewiseXns);

			let nextTask = null;
			for (const task of parsedTasks) {
				if (!task?.DT) continue;
				// Only consider active tasks (Sts === 1) - completed/cancelled tasks were
				// leaking in here and winning on DT comparison, showing stale dates.
				if (Number(task.Sts || task.status || 0) !== 1) continue;
				if (!nextTask || task.DT < nextTask.DT) nextTask = task;
			}
			const threadOpenCounts = {};
			const threadAllCounts = {};
			const xnsAllCounts = {};

			// Initialize counts for all thread types
			threadType.forEach(tt => {
				if (tt.Flow === 'In') {
					threadOpenCounts[`cntIn${tt.Sn}Open`] = 0;
					threadAllCounts[`cntIn${tt.Sn}All`] = 0;
					xnsAllCounts[`cntXns${tt.TID}All`] = 0;
				} else if (tt.Flow === 'Out') {
					threadOpenCounts[`cntOut${tt.Sn}Open`] = 0;
					threadAllCounts[`cntOut${tt.Sn}All`] = 0;
					xnsAllCounts[`cntXns${tt.TID}All`] = 0;
				}
			});

			// Fill in actual counts from data
			for (const row of cntTypewiseThreads) {
				const threadTypeInfo = threadType.find(tt => tt.TID === row.TID);
				if (threadTypeInfo) {
					if (threadTypeInfo.Flow === 'In') {
						threadOpenCounts[`cntIn${threadTypeInfo.Sn}Open`] = row.CntOpen || 0;
						threadAllCounts[`cntIn${threadTypeInfo.Sn}All`] = row.CntAll || 0;
					} else if (threadTypeInfo.Flow === 'Out') {
						threadOpenCounts[`cntOut${threadTypeInfo.Sn}Open`] = row.CntOpen || 0;
						threadAllCounts[`cntOut${threadTypeInfo.Sn}All`] = row.CntAll || 0;
					}
				}
			}

			for (const row of cntTypewiseXns) {
				xnsAllCounts[`cntXns${row.TID}All`] = row.CntAll || 0;
			}

			// Process custom fields for this connection
			const customFields = parseCustomFields(item.CustomFields);
			const customFieldValues = {};
			customFields.forEach(field => {
				if (field.F && field.V) {
					customFieldValues[`customField_${field.F}`] = field.V;
				}
			});

			const segmentInfo = segmentsWithColors.find(s => s.CNm === item.Segment);
			const segmentColor = segmentInfo?.Clr || null;

			return {
				connID: item.ConnID,
				bizName: item.BizName,
				contactName: item.ContactName,
				mainQty: item.MainQty,
				contacts: item.Contacts,
				pocUserID: item.POCUserID,
				pocUserIDs: item.POCUserIDs,
				mobile: item.Mobile,
				sentiment: item.Sentiment,
				fdbkScore: item.FdbkScore,
				lastFdbkReqDT: item.LastFdbkReqDT,
				fdbkNotes: item.FdbkNotes,
				segment: item.Segment,
				segmentColor: segmentColor,
				cc: item.CC,
				connTypes: item.ConnType,
				email: item.Email,
				pocUserName: getExecutiveName(item.POCUserID),
				potential: item.Potential,
				sinceDT: item.SinceDT,
				sinceDTF: formatDate(item.SinceDT),
				lastRecDT: item.LastRecDT || null,
				lastRecDTF: (() => {
					const rawDT = item.LastRecDT;
					if (!rawDT) return null;
					const formatted = formatDate(rawDT);
					return formatted === "-" ? null : formatted;
				})(),
				lastRecDTColor: getTaskColor(item.LastRecDT),
				lastThreadDT: item.LastThreadDT,
				lastRecDate: item.LastRecDate,
				nextTaskDT: nextTask?.DT,
				nextTaskDTColor: getTaskColor(nextTask?.DT),
				nextTaskDTF: formatDate(nextTask?.DT),
				nextTaskNote: nextTask?.Txt,
				nextTaskTyp: nextTask?.Typ,
				countryID: item.CountryID,
				country: item.Country,
				stateID: item.StateID,
				state: item.State,
				city: item.City,
				source: item.Source,
				cntXns: item.CntXns,
				CustomFields: item.CustomFields, // Keep original for processing
				regionID: item.RegionID,
				ctrcIDs: item.CtrcIDs,
				isCold: item.IsCold || 0,
				...threadOpenCounts,
				...threadAllCounts,
				...xnsAllCounts,
				...customFieldValues
			};
		});
		setConnections(processed);
		dispatch(setGlobalLoading(false));
	}, [permissionFilteredConnections, threadType]);

	// Populate cold connections when connections data changes
	useEffect(() => {
		const cold = connections.filter(conn => conn.isCold === 1 || conn.isCold === true);
		setColdConnections(cold);
	}, [connections]);

	const getColdContactsWithTasksDueToday = (taskData, connectionData) => {
		if (!Array.isArray(taskData) || !Array.isArray(connectionData)) {
			return {
				dueTodayCount: 0,
				dueTodayContacts: [],
				allColdContactsWithTasks: []
			};
		}

		const coldContacts = connectionData.filter(conn => conn.IsCold === 1 || conn.IsCold === true);

		const coldContactsWithTasks = coldContacts.map(conn => {
			const connTasks = taskData.filter(task => task.ConnID === conn.ConnID && task.Status === 1);

			if (connTasks.length === 0) {
				return null;
			}

			const oldestTask = connTasks.reduce((oldest, current) => {
				const currentDate = new Date(current.DueDT);
				const oldestDate = new Date(oldest.DueDT);
				return currentDate < oldestDate ? current : oldest;
			});

			return {
				ConnID: conn.ConnID,
				BizName: conn.BizName || "",
				ContactName: conn.ContactName || "",
				Mobile: conn.Mobile || "",
				Email: conn.Email || "",
				CC: conn.CC || "",
				IsCold: conn.IsCold,
				OldestTaskDueDate: new Date(oldestTask.DueDT).toISOString(),
				OldestTaskDueDateObj: new Date(oldestTask.DueDT),
				OldestTaskTitle: oldestTask.Task || "",
				OldestTaskID: oldestTask.TaskID,
				TaskCount: connTasks.length,
				POCUserID: oldestTask.POCUserID,
				Priority: oldestTask.Priority || "Medium"
			};
		}).filter(item => item !== null);

		const today = new Date();
		today.setHours(0, 0, 0, 0);
		const endOfToday = new Date(today);
		endOfToday.setHours(23, 59, 59, 999);

		const dueTodayContacts = coldContactsWithTasks.filter(contact => {
			const dueDate = new Date(contact.OldestTaskDueDate);
			dueDate.setHours(0, 0, 0, 0);
			return dueDate.getTime() <= today.getTime();
		});

		const priorityOrder = { 'High': 0, 'Medium': 1, 'Low': 2 };
		dueTodayContacts.sort((a, b) => {
			const aPriority = priorityOrder[a.Priority] ?? 99;
			const bPriority = priorityOrder[b.Priority] ?? 99;
			return aPriority - bPriority;
		});

		return {
			dueTodayCount: dueTodayContacts.length,
			dueTodayContacts: dueTodayContacts,
			allColdContactsWithTasks: coldContactsWithTasks
		};
	};

	const coldContactsDueData = getColdContactsWithTasksDueToday(taskData, connectionData);

	const handleRowClick = (connection) => {
		setSelectedConnection(connection);
		setIsDetailOpen(true);
	};

	const handleDetailClose = () => {
		setIsDetailOpen(false);
		setSelectedConnection(null);
	};

	const renderMobileCard = (connection) => {
		const isExpanded = expandedConnID === connection.connID;
		const isNaMode = selectedFilters.noActivity !== 'all' || Boolean(searchParams.get('na') || searchParams.get('NA'));
		// Last record date, stored on the connection (IndexedDB/Redux) as LastRecDT.
		const lastRecDT = connection.lastRecDT || null;

		const handleCardClick = () => {
			if (isExpanded) {
				setExpandedConnID(null);
			} else {
				handleRowClick(connection);
			}
		};

		return (
			<div
				key={connection.connID}
				onClick={handleCardClick}
				className="bg-sahi-white sahi-radius shadow-sm border border-gray-200 mb-2 w-full f-col justify-between cursor-pointer transition-all duration-200"
			>
				<div className="f-row justify-between mobile-tile-header-layout-v3 mb-1.5">

					<div className="f-col justify-between gap-1 items-start">
						<div className="f-row items-center justify-between">
							<div className="f-row min-w-0 gap-1.5 items-center">
								<span
									className="w-2 h-2 rounded-full flex-shrink-0"
									style={{ backgroundColor: connection.segmentColor || "#d1d5db" }}
								/>
								<span className="font-semibold text-text-color break-words text-sm ">
									{connection.bizName || connection.contactName || "-"}
								</span>
							</div>
						</div>
						<div className='f-row justify-between gap-1 items-center align-middle'>
							<span className="text-xs text-sub-text-color truncate">
								{connection.bizName ? (connection.contactName || "-") : "-"}
							</span>
						</div>
					</div>
					<div className="f-col justify-between gap-1 text-right">
						<div className="f-col items-end text-right">
							<div className='f-row justify-end gap-2'>
								<SentimentIcon sentiment={connection.sentiment} />
								{connection.potential > 0 && (
									<span
										className={cn(
											"text-xs font-semibold text-gray-800 tracking-tight whitespace-nowrap flex-shrink-0",
											(() => {
												const hasCustomerActivity = threadType.some(
													(tt) => tt.Flow === "In" && connection[`cntIn${tt.Sn}Open`] > 0
												);
												return hasCustomerActivity ? "!text-sahi-green " : "!text-sahi-blue";
											})()
										)}
									>
										{currencySymbol} {formatAmount(connection.potential, agencyData?.CountryID)}
									</span>
								)}
							</div>
						</div>
						<div className="f-row items-center justify-end gap-1 text-xs text-sub-text-color truncate">
							{connection.segment && (
								<span className="truncate">{connection.segment}</span>
							)}
							{isNaMode && (
								<span className="whitespace-nowrap text-sub-text-color">
									Last: <strong className={lastRecDT ? "text-text-color" : "text-sahi-red"}>{lastRecDT ? getRelativeDateText(lastRecDT, false, false) : "Never"}</strong>
								</span>
							)}
						</div>
					</div>
				</div>

				{/* === Expanded Details Section with smooth transition (Image 3 & 4 design) === */}
				<div
					className={cn(
						"grid transition-all duration-200 ease-in-out border-gray-200",
						isExpanded ? "grid-rows-[1fr] opacity-100 border-t border-dashed" : "grid-rows-[0fr] opacity-0 border-t-0"
					)}
				>
					<div className="overflow-hidden">
						<div
							className="p-2.5 flex flex-col gap-2 cursor-default select-none"
							onClick={(e) => e.stopPropagation()}
						>
							{/* L1: Notes Input with SpeechControls */}
							<div className="relative w-full">
								<Input
									type="text"
									id={`quick-notes-${connection.connID}`}
									maxLength={1000}
									value={quickRecordData.notes}
									onChange={(e) => setQuickRecordData(prev => ({ ...prev, notes: e.target.value }))}
									placeholder="Enter Notes"
									className="w-full text-zinc-900 border !border-green-700/50 focus:border-[var(--sahi-green)] transition-all font-normal leading-tight text-left !h-10 text-sm px-3 pr-16 bg-white"
									onKeyDown={(e) => {
										if (e.key === 'Enter') {
											handleSaveQuickRecord(connection);
										}
									}}
								/>
								<SpeechControls
									targetId={`quick-notes-${connection.connID}`}
									value={quickRecordData.notes}
									onChange={(val) => setQuickRecordData(prev => ({ ...prev, notes: val }))}
									isMobile={isMobile}
								/>
							</div>

							{/* L2: Type selection button, Date icon button, and Submit (+) button in one row */}
							<div className="flex items-center gap-2 w-full">
								{/* Type Selection Button opening Select Record Type Drawer */}
								<Button
									type="button"
									variant="outline"
									onClick={() => setOpenRecordTypeDropdown(true)}
									className="flex-1 min-w-0 flex items-center justify-between !h-10 px-3 !border-green-700/50 bg-white hover:bg-zinc-50 hover:text-foreground text-foreground text-sm font-normal text-left cursor-pointer"
								>
									<span className="truncate">{quickRecordData.recordType || 'Type'}</span>
									<ChevronDown className="h-4 w-4 text-zinc-400 shrink-0 ml-1" />
								</Button>

								{/* Date Icon Button with Popover Calendar */}
								<Popover open={datePickerConnID === connection.connID} onOpenChange={(open) => setDatePickerConnID(open ? connection.connID : null)}>
									<PopoverTrigger asChild>
										<Button
											type="button"
											variant="outline"
											className="!h-10 !w-10 shrink-0 p-0 flex items-center justify-center !border-green-700/50 bg-white hover:bg-zinc-50 text-foreground cursor-pointer rounded-md"
											title={`Date: ${quickRecordData.recordDate}`}
										>
											<CalendarIcon className="h-4 w-4 text-zinc-600" />
										</Button>
									</PopoverTrigger>
									<PopoverContent className="w-auto p-0 bg-white border border-gray-200 shadow-lg z-[10030]" align="end" sideOffset={5}>
										<Calendar
											mode="single"
											selected={(() => {
												if (!quickRecordData.recordDate) return new Date();
												try {
													const parsed = parse(quickRecordData.recordDate, 'dd-MMM-yy', new Date());
													return isNaN(parsed.getTime()) ? new Date(quickRecordData.recordDate) : parsed;
												} catch (e) {
													return new Date();
												}
											})()}
											captionLayout="dropdown"
											className="rdp-dropdown-custom"
											fixedWeeks={true}
											onSelect={(date) => {
												if (date) {
													setQuickRecordData(prev => ({ ...prev, recordDate: format(date, "dd-MMM-yy") }));
													setDatePickerConnID(null);
												}
											}}
											disabled={(date) => {
												const today = new Date();
												today.setHours(0, 0, 0, 0);
												return date > today;
											}}
										/>
									</PopoverContent>
								</Popover>

								{/* Submit (+) Button */}
								<Button
									type="button"
									onClick={() => handleSaveQuickRecord(connection)}
									disabled={isSavingQuickRecord || !quickRecordData.notes?.trim()}
									className="!h-10 !w-10 shrink-0 p-0 flex items-center justify-center bg-[var(--sahi-green)] hover:bg-[var(--sahi-green)]/90 text-white rounded-md cursor-pointer"
								>
									{isSavingQuickRecord ? (
										<Loader2 className="h-4 w-4 animate-spin text-white" />
									) : (
										<Plus className="h-5 w-5 text-white" strokeWidth={3} />
									)}
								</Button>
							</div>
						</div>
					</div>
				</div>

				{/* === Footer Section with smooth transition === */}
				<div
					className={cn(
						"grid transition-all duration-200 ease-in-out border-[#f1f1f1]",
						!isExpanded ? "grid-rows-[1fr] opacity-100 border-t" : "grid-rows-[0fr] opacity-0 border-t-0"
					)}
				>
					<div className="overflow-hidden">
						<div
							className="flex h-[38px] justify-between items-center text-xs w-full mobile-tile-footer-layout px-2"
							onClick={(e) => {
								if (isNaMode) {
									e.stopPropagation();
									handleToggleQuickInteraction(connection);
								}
							}}
						>
							<div className="flex flex-wrap gap-3 items-center flex-1 min-w-0">
								{isNaMode ? (
									<span className="whitespace-nowrap cursor-pointer flex items-center">
										<strong>
											<span className="flex items-center gap-0.5">
												<Plus className="h-3.5 w-3.5 stroke-[2.5]" />
												Interaction
											</span>
										</strong>
									</span>
								) : (
									<>
										{/* Dynamically render thread counts based on thread types */}
										{threadType.filter(tt => tt.Flow === 'In').map(tt => {
											const countKey = `cntIn${tt.Sn}Open`;
											const count = connection[countKey] || 0;
											if (count > 0) {
												const threadMeta = getThreadTypeMeta(tt.TID, threadType);
												return (
													<span key={countKey} className="flex items-center gap-1 text-sahi-green">
														<threadMeta.Icon className="w-3 h-3" />
														{count}
													</span>
												);
											}
											return null;
										})}
										{threadType.filter(tt => tt.Flow === 'Out').map(tt => {
											const countKey = `cntOut${tt.Sn}Open`;
											const count = connection[countKey] || 0;
											if (count > 0) {
												const threadMeta = getThreadTypeMeta(tt.TID, threadType);
												return (
													<span key={countKey} className="flex items-center gap-1 text-sahi-orange">
														<threadMeta.Icon className="w-3 h-3" />
														{count}
													</span>
												);
											}
											return null;
										})}
										{(() => {
											// Check if any thread counts exist
											const hasAnyThreadCounts = threadType.some(tt => {
												const countKey = tt.Flow === 'In' ? `cntIn${tt.Sn}Open` : `cntOut${tt.Sn}Open`;
												return connection[countKey] > 0;
											});

											if (!hasAnyThreadCounts) {
												return connection?.nextTaskDT ? (
													<span className="whitespace-nowrap">
														Next: <strong>
															<span style={{ color: getTaskColor(connection.nextTaskDT) }}>
																{connection.nextTaskDTF}
															</span>
														</strong>{" "}
														{connection?.nextTaskTyp ? `(${connection.nextTaskTyp})` : ""}
													</span>
												) : (
													<span className="whitespace-nowrap">
														<strong>
															<span>
																No {isInqMode ? "Inquiries" : "Threads"}
															</span>
														</strong>
													</span>
												);
											}
											return null;
										})()}
									</>
								)}
							</div>
							<div className="flex gap-5 text-lg justify-end">
								{connection?.mobile && (
									<button
										onClick={(e) => {
											e.stopPropagation();
											const isDesktop = typeof window !== 'undefined' && window.innerWidth > 768;
											handlePhoneClickAction(connection, isDesktop,);
										}}
										className="hover:opacity-80 transition-opacity"
									>
										<MdPhone className="w-4.5 h-4.5 text-black" />
									</button>
								)}
								{connection?.mobile && (
									<button
										className="text-sahi-green hover:opacity-80 transition-opacity"
										onClick={(e) => {
											e.stopPropagation();
											setTemplateDialogOpen(true);
											setIsTemplateDialogActive(true); // Mark as active
											setTemplateDialogData(connection);
										}}
									>
										<BsWhatsapp className="w-4.5 h-4.5 hover:bg-sahi-green-light" />
									</button>
								)}
								{(connection.connTypes.includes('C') && connection?.mobile) &&
									<div
										className="text-sahi-blue"
										onClick={(e) => {
											e.stopPropagation();
											setSelectedConnectionForWsp(connection);
											setIsWspDialogOpen(true);
										}}
									>
										<BsBellFill className="w-4.5 h-4.5 hover:bg-sahi-blue-light" />
									</div>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};





	// sortData - sort the data based on the key (for mobile view)
	const sortData = (key) => {
		let direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
		setSortConfig({ key, direction });

		const sorted = [...filteredConnections].sort((a, b) => {
			let aValue = a[key] || '';
			let bValue = b[key] || '';
			// Check if the key is a thread count key (starts with cntIn or cntOut and ends with Open)
			if (key === "activity") {
				const calcActivity = (connection) => {
					let total = 0;
					threadType.forEach((tt) => {
						if (tt.Flow === "In") {
							total += connection[`cntIn${tt.Sn}Open`] || 0;
						} else if (tt.Flow === "Out") {
							total += connection[`cntOut${tt.Sn}Open`] || 0;
						}
					});
					return total;
				};
				aValue = calcActivity(a);
				bValue = calcActivity(b);
				return direction === "asc" ? aValue - bValue : bValue - aValue;
			}
			if (key === 'potential' || (key.startsWith('cntIn') && key.endsWith('Open')) || (key.startsWith('cntOut') && key.endsWith('Open'))) {
				aValue = Number(aValue) || 0;
				bValue = Number(bValue) || 0;
				return direction === 'asc' ? aValue - bValue : bValue - aValue;
			}
			if (key === 'sinceDT' || key === 'lastRecDT' || key === 'nextTaskDT') {
				aValue = aValue ? new Date(aValue).getTime() : 0;
				bValue = bValue ? new Date(bValue).getTime() : 0;
				return direction === 'asc' ? aValue - bValue : bValue - aValue;
			}
			// Handle custom field sorting
			if (key.startsWith('customField_')) {
				aValue = aValue.toString().toLowerCase();
				bValue = bValue.toString().toLowerCase();
				return direction === 'asc'
					? aValue.localeCompare(bValue)
					: bValue.localeCompare(aValue);
			}
			if (key === 'bizName') {
				aValue = (a.bizName && a.bizName !== '-') ? a.bizName.toLowerCase() : (a.contactName || '').toLowerCase();
				bValue = (b.bizName && b.bizName !== '-') ? b.bizName.toLowerCase() : (b.contactName || '').toLowerCase();
				return direction === 'asc'
					? aValue.localeCompare(bValue)
					: bValue.localeCompare(aValue);
			}
			aValue = aValue.toString().toLowerCase();
			bValue = bValue.toString().toLowerCase();
			return direction === 'asc'
				? aValue.localeCompare(bValue)
				: bValue.localeCompare(aValue);
		});

		setFilteredConnections(sorted);
	};

	// applyFilters - apply the filters to the data
	const applyFilters = () => {
		dispatch(setGlobalLoading(true))
		const {
			city,
			state,
			country,
			segment,
			assignedTo,
			lastContact,
			notContacted,
			nextTask,
			noActivity,
			lastActivity,
			sentiment,
			contactCategory,
			region
		} = selectedFilters;

		const params = new URLSearchParams(location.search);
		const isLostCustomerView = params.has('na') || params.has('NA');

		// Requirement: If na is present, "Lost Customers", else "Contacts"
		let headerTitle = isLostCustomerView ? "Lost Customers" : "Contacts";

		// Map contactCategory to connection type and status for header
		const categoryStatusMap = {
			'FutureProspect': { type: 'P', status: 'future', label: 'Prospects' },
			'CurrentCustomer': { type: 'C', status: 'active', label: 'Current Customers' },
			'InactiveCustomer': { type: 'C', status: 'inactive', label: 'Inactive Customers' },
			'Supplier': { type: 'S', status: 'all', label: 'Suppliers' },
			'Other': { type: 'O', status: 'all', label: 'Others' },
			'cold': { type: 'all', status: 'all', label: 'Cold Contacts' }
		};

		const categoryInfo = categoryStatusMap[contactCategory];
		if (categoryInfo && contactCategory !== 'all') {
			headerTitle = categoryInfo.label;
		}

		let selectedHeader = {
			title: headerTitle,
			iconLeft: {
				icon: ArrowLeft,
				onClick: () => {
					if (isLostCustomerView) {
						navigate(-1);
					} else {
						navigate("/", { replace: true });
					}
				}
			},
			actionsRight: []
		};
		if (!embedded) {
			dispatch(updateHeaderConfig(selectedHeader));
		}

		// Always filter from the full list to prevent overlap/narrowing bugs when changing filters
		let baseList = showColdContactsOnly ? coldConnections : connections;

		const filtered = [];

		// Process each connection through filters
		for (const connection of baseList) {

			const isColdContact = connection.isCold === 1 || connection.isCold === true;

			// Skip cold/non-cold filtering if already filtered by baseList
			if (!showColdContactsOnly) {
				// When NOT showing cold contacts only, exclude cold contacts
				if (isColdContact) {
					continue;
				}
			}

			// NEW: Handle merged contactCategory filter
			if (contactCategory !== 'all' && contactCategory !== 'cold' && contactCategory !== 'regular') {
				let passesContactCategoryFilter = false;

				if (contactCategory === 'FutureProspect') {
					// Future Prospects: Prospects with no activity
					if (!connection.connTypes || !connection.connTypes.includes('P')) {
						continue;
					}
					if (!threadType || threadType.length === 0) {
						passesContactCategoryFilter = true;
					} else {
						const totalAllCount = threadType
							.filter(tt => [2, 3].includes(tt.TID))
							.reduce((sum, tt) => {
								const allVal = tt.Flow === 'In'
									? (connection[`cntIn${tt.Sn}All`] || 0)
									: (connection[`cntOut${tt.Sn}All`] || 0);
								return sum + allVal;
							}, 0);
						const hasXns = [1, 3, 5].some(xn => (connection[`cntXns${xn}All`] || 0) > 0);
						const hasContracts = connection.ctrcIDs && connection.ctrcIDs.trim() !== '';
						passesContactCategoryFilter = !hasXns && totalAllCount === 0 && !hasContracts;
					}
				} else if (contactCategory === 'CurrentCustomer') {
					// Current Customers: Active Customers
					if (!connection.connTypes || !connection.connTypes.includes('C')) {
						continue;
					}
					// Current Customers: Any customer (not cold) - show all active customers
					passesContactCategoryFilter = true;
				} else if (contactCategory === 'InactiveCustomer') {
					// Inactive Customers: Must be a customer
					if (!connection.connTypes || !connection.connTypes.includes('C')) {
						continue;
					}
					passesContactCategoryFilter = true;
				} else if (contactCategory === 'Supplier') {
					// Suppliers: Must be a supplier ('S')
					if (!connection.connTypes || !connection.connTypes.includes('S')) {
						continue;
					}
					passesContactCategoryFilter = true;
				} else if (contactCategory === 'Other') {
					// Others: Must be 'O' or other type
					if (!connection.connTypes || !connection.connTypes.includes('O')) {
						continue;
					}
					passesContactCategoryFilter = true;
				}

				if (!passesContactCategoryFilter) continue;
			}

			if (country !== 'all' && connection.country.toLowerCase() !== country.toLowerCase()) continue;
			if (state !== 'all' && connection.state.toLowerCase() !== state.toLowerCase()) continue;
			if (city !== 'all' && connection.city.toLowerCase() !== city.toLowerCase()) continue;
			if (region !== 'all' && connection.regionID != region) continue;

			// Segment filter
			if (segment !== 'all' && connection.segment !== segment) continue;

			if (
				assignedTo !== "all"
			) {
				if (assignedTo === "unassigned") {
					if (connection.pocUserID || (connection.pocUserIDs && connection.pocUserIDs.trim() !== '')) continue;
				} else {
					const selectedUserID = String(assignedTo);
					let isMatch = false;

					if (connection.pocUserID && String(connection.pocUserID) === selectedUserID) {
						isMatch = true;
					} else if (connection.pocUserIDs) {
						const ids = connection.pocUserIDs.split(',').map(id => id.trim());
						if (ids.includes(selectedUserID)) {
							isMatch = true;
						}
					}

					if (!isMatch) continue;
				}
			}

			// Last Contact filter
			if (lastContact !== 'all') {
				const now = new Date();
				const lastRec = connection.lastRecDT ? new Date(connection.lastRecDT) : null;

				let passesLastContactFilter = false;

				switch (lastContact) {
					case 'None':
						passesLastContactFilter = !lastRec;
						break;
					case 'Today':
						passesLastContactFilter = lastRec && isSameDay(lastRec, now);
						break;
					case 'Yesterday':
						passesLastContactFilter = lastRec && isSameDay(lastRec, addDays(now, -1));
						break;
					case 'Last 7 days':
						passesLastContactFilter = lastRec && lastRec >= addDays(now, -7);
						break;
					case 'Last 30 days':
						passesLastContactFilter = lastRec && lastRec >= addDays(now, -30);
						break;
					case 'Last 3 months':
						passesLastContactFilter = lastRec && lastRec >= addMonths(now, -3);
						break;
					case 'Last 6 months':
						passesLastContactFilter = lastRec && lastRec >= addMonths(now, -6);
						break;
					default:
						passesLastContactFilter = true;
				}
				if (!passesLastContactFilter) continue;
			}

			// Not Contacted In filter
			if (notContacted !== 'all') {
				const now = new Date();
				const lastRec = connection.lastRecDT ? new Date(connection.lastRecDT) : null;
				let passesNotContactedFilter = false;

				switch (notContacted) {
					case 'Last 7 days':
						passesNotContactedFilter = !lastRec || lastRec < addDays(now, -7);
						break;
					case 'Last 30 days':
						passesNotContactedFilter = !lastRec || lastRec < addDays(now, -30);
						break;
					case 'Last 3 months':
						passesNotContactedFilter = !lastRec || lastRec < addMonths(now, -3);
						break;
					case 'Last 6 months':
						passesNotContactedFilter = !lastRec || lastRec < addMonths(now, -6);
						break;
					case 'More than 6 months':
						passesNotContactedFilter = !lastRec || lastRec < addMonths(now, -12);
						break;
					default:
						passesNotContactedFilter = true;
				}
				if (!passesNotContactedFilter) continue;
			}

			// Next Task filter
			if (nextTask !== 'all') {
				const now = new Date();
				const nextTaskDate = connection.nextTaskDT ? new Date(connection.nextTaskDT) : null;

				let passesNextTaskFilter = false;
				switch (nextTask) {
					case 'Next Action Not Set':
						passesNextTaskFilter = !nextTaskDate;
						break;
					case 'Next Action Overdue':
						passesNextTaskFilter = nextTaskDate && nextTaskDate < now;
						break;
					case 'Next Action Today':
						passesNextTaskFilter = nextTaskDate && isSameDay(nextTaskDate, now);
						break;
					case 'Next Action Tomorrow':
						passesNextTaskFilter = nextTaskDate && isSameDay(nextTaskDate, addDays(now, 1));
						break;
					case 'Next Action Next 7 days':
						passesNextTaskFilter = nextTaskDate && (nextTaskDate >= now && nextTaskDate <= addDays(now, 7));
						break;
					case 'Next Action Next 30 days':
						passesNextTaskFilter = nextTaskDate && (nextTaskDate >= now && nextTaskDate <= addDays(now, 30));
						break;
					default:
						passesNextTaskFilter = true;
				}

				if (!passesNextTaskFilter) continue;
			}

			// All Activity In filter - shows connections with no activity in specified time period
			if (noActivity !== 'all') {
				const now = new Date();
				// EXCLUSION FILTERS
				// 1. Exclude Prospects
				if (connection.connTypes && connection.connTypes.includes('P')) continue;

				const lastActivityDate = connection.lastThreadDT ? new Date(connection.lastThreadDT) : null;

				let passesNoActivityFilter = false;
				switch (noActivity) {
					case 'Unknown':
						// Unknown (na=0): No recorded thread ever
						passesNoActivityFilter = !lastActivityDate;
						break;
					case 'Inactive for last 7 days':
						// Inactive for last 7 days (na=1): No activity during the past 7 days (or never)
						passesNoActivityFilter = !lastActivityDate || lastActivityDate < addDays(now, -7);
						break;
					case 'Inactive for last 30 days':
						// Inactive for last 30 days (na=2): 30 to 90 days only
						passesNoActivityFilter = lastActivityDate && lastActivityDate < addDays(now, -30) && lastActivityDate >= addDays(now, -90);
						break;
					case 'Inactive for last 60 days':
						// Inactive for last 60 days (na=3): No activity during the past 60 days (or never)
						passesNoActivityFilter = !lastActivityDate || lastActivityDate < addDays(now, -60);
						break;
					case 'Inactive for last 3 months':
						// Inactive for last 3 months (na=4): 90+ days only
						passesNoActivityFilter = lastActivityDate && lastActivityDate < addDays(now, -90);
						break;
					case 'Inactive for last 6 months':
						// Inactive for last 6 months (na=5): No activity during the past 6 months (or never)
						passesNoActivityFilter = !lastActivityDate || lastActivityDate < addMonths(now, -6);
						break;
					case 'More than 6 months':
						// More than 6 months (na=6): No activity during the past 12 months (or never)
						passesNoActivityFilter = !lastActivityDate || lastActivityDate < addMonths(now, -12);
						break;
					default:
						passesNoActivityFilter = true;
				}

				if (!passesNoActivityFilter) continue;
			}
			// Last Activity filter - shows connections with activity in specified time period
			if (lastActivity !== 'all') {
				const now = new Date();

				const lastActivityDate = connection.lastThreadDT ? new Date(connection.lastThreadDT) : null;
				let passesLastActivityFilter = false;

				switch (lastActivity) {
					case 'Last 7 days':
						passesLastActivityFilter = lastActivityDate && lastActivityDate >= addDays(now, -7);
						break;
					case 'Last 30 days':
						passesLastActivityFilter = lastActivityDate && lastActivityDate >= addDays(now, -30);
						break;
					case 'Last 3 months':
						passesLastActivityFilter = lastActivityDate && lastActivityDate >= addMonths(now, -3);
						break;
					case 'Last 6 months':
						passesLastActivityFilter = lastActivityDate && lastActivityDate >= addMonths(now, -6);
						break;
					case 'More than 6 months':
						passesLastActivityFilter = lastActivityDate && lastActivityDate < addMonths(now, -6);
						break;
					default:
						passesLastActivityFilter = true;
				}

				if (!passesLastActivityFilter) continue;
			}

			if (sentiment && sentiment.toLowerCase() !== 'all') {
				const connectionSentiment = (connection.sentiment || '').toLowerCase();
				if (!sentimentMap[connectionSentiment]?.includes(sentiment.toLowerCase())) {
					continue;
				}
			}

			// Active sentiment filter (from count boxes)
			if (activeSentimentFilter && (selectedFilters.contactCategory === 'CurrentCustomer' || selectedFilters.contactCategory === 'InactiveCustomer')) {
				const score = connection.fdbkScore;
				let passesSentimentFilter = false;

				switch (activeSentimentFilter) {
					case 'happy':
						passesSentimentFilter = score >= 4 && score <= 5;
						break;
					case 'unhappy':
						passesSentimentFilter = score >= 1 && score < 4;
						break;
					case 'unknown':
						passesSentimentFilter = !score || score < 1 || score > 5;
						break;
					default:
						passesSentimentFilter = true;
				}

				if (!passesSentimentFilter) continue;
			}
			// If connection passed all filters, add to filtered results
			filtered.push(connection);
		}

		// Apply search term filter if exists
		let finalFiltered = filtered;
		if (debouncedSearchTerm && debouncedSearchTerm.trim()) {
			const term = debouncedSearchTerm.toLowerCase().trim();
			const searchWords = term.split(' ').filter(word => word.length > 0);

			finalFiltered = filtered.filter(connection => {
				// Create searchable text once per connection
				const searchableText = [
					connection.contactName,
					connection.bizName,
					connection.email,
					connection.mobile,
					connection.pocUserName,
					connection.nextTaskTyp,
					connection.potential?.toString(),
					...customFieldColumns.map(col => connection[col.key])
				].filter(Boolean).join(' ').toLowerCase();

				// Check if all search words are present
				return searchWords.every(word => searchableText.includes(word));
			});
		}

		// Update state
		if (showColdContactsOnly) {
		} else {
		}
		setFilteredConnections(finalFiltered);
		// setPreSearchConnections(finalFiltered); // Save before search (if you have this state)
		setCurrentPage(1);
		if (connectionData.length > 0 && connections.length != 0) {
			setIsInitLoading(false);
		}

		// Store current filters for next comparison
		prevFiltersRef.current = {
			city,
			state,
			country,
			segment,
			assignedTo,
			lastContact,
			notContacted,
			nextTask,
			noActivity,
			lastActivity,
			sentiment,
			// status,
			// t,
			region
		};

		dispatch(setGlobalLoading(false))
	};

	const totalPages = Math.ceil(filteredConnections.length / rowsPerPage);
	const startIndex = (currentPage - 1) * rowsPerPage;
	const endIndex = startIndex + rowsPerPage;

	const handleCancel = () => {
		setTempFilters(selectedFilters);
		setIsDrawerOpen(false);
		setIsFilterSelected(false);
		// setTempsortConfig(sortConfig);
	};

	const handleResetFilters = () => {
		const cleared = {
			city: 'all',
			state: 'all',
			country: 'all',
			segment: 'all',
			assignedTo: 'all',
			lastContact: 'all',
			notContacted: 'all',
			nextTask: 'all',
			noActivity: 'all',
			lastActivity: 'all',
			sentiment: 'all',
			contactCategory: 'all',
			region: 'all'
		};
		setSortConfig({ key: null, direction: null });
		setSelectedFilters(prev => ({ ...prev, ...cleared }));
		setSearchTerm("");
		setIsDrawerOpen(false);
		setIsFilterSelected(false);
		setTempFilters(cleared);
		setTempsortConfig({ key: null, direction: null });
		setActiveSentimentFilter(null);
		setShowColdContactsOnly(false);

		// Clear all URL parameters by navigating to clean path
		navigate(location.pathname, { replace: true });
	};

	const handleSentimentClick = (e, connection) => {
		e.stopPropagation();
		setFdbkReqState({
			openDialog: true,
			connID: connection?.connID,
			connBizName: connection?.bizName,
			connMobile: connection?.mobile,
			connCC: connection?.cc,
			connEmail: connection?.email,
			connContactName: connection?.contactName
		})
	}

	// Function which will handle sentiment request
	const handleFdbkRequest = async () => {
		const sendByTool = {
			sendByEmail: false,
			sendByWsp: true
		}

		const apiData = {
			connID: fdbkReqState?.connID,
			connMobile: fdbkReqState?.connMobile,
			connCC: fdbkReqState?.connCC,
			bizName: fdbkReqState?.connBizName,
			contactPerson: fdbkReqState?.connContactName,
			email: fdbkReqState?.connEmail,
			userMobile: currentUser.Mobile,
			username: currentUser.Name,
			userID: currentUser.UserID,
			sendByEmail: sendByTool.sendByEmail,
			sendByWsp: sendByTool.sendByWsp
		}
		dispatch(setGlobalLoading(true));
		try {
			const result = await manageFdbkRequestAPI(apiData);
			if (result.error == false) {
				if (sendByTool.sendByEmail) {
					toast.success("Email sent for sentiment request.")
				}
				else {
					toast.success("Whatsapp message sent for sentiment request.")
				}
			}
		} catch (err) {
			console.error('Error while sending sentiment request', err)
		} finally {
			dispatch(setGlobalLoading(false));
		}
	}

	// Function to handle export
	const handleExportToExcel = () => {
		const fileName = `${connTypeInfo.label || "Contacts"}List`;

		// Filter tableHeaderCols to only include visible columns
		const visibleHeaders = tableHeaderCols.filter(col => {
			if (col.key.startsWith('cntIn') || col.key.startsWith('cntOut') || col.key.startsWith('customField_') || col.key === 'activity') {
				return true; // Always include dynamic columns
			}
			return columnVisibility[col.key] === true; // Include base columns if visible
		});

		exportToExcel(filteredConnections, visibleHeaders, fileName, connectionValueMapper);
		toast.success(`Exporting ${filteredConnections.length} ${connTypeInfo.label.toLowerCase()}.`);
	};

	const connectionValueMapper = (connection, key) => {
		switch (key) {
			case 'bizName':
				return connection.bizName || "-";
			case 'contactName':
				return connection.contactName || "-";
			case 'potential':
				// Return the raw number for better Excel functionality
				return connection.potential || 0;
			case 'activity':
				// Calculate total activity (sum of open thread counts for customer/supplier flow)
				let totalActivity = 0;
				threadType.forEach(tt => {
					const countKey = tt.Flow === 'In' ? `cntIn${tt.Sn}Open` : `cntOut${tt.Sn}Open`;
					totalActivity += connection[countKey] || 0;
				});
				return totalActivity;
			case 'sinceDT':
				return connection.sinceDTF || "-";
			case 'lastRecDT':
				return connection.lastRecDTF || "-";
			case 'nextTaskDT':
				return connection.nextTaskDTF && connection.nextTaskDTF !== '-'
					? `${connection.nextTaskDTF}${connection.nextTaskTyp ? ` - ${connection.nextTaskTyp}` : ''}`
					: "-";
			case 'pocUserID':
				return connection.pocUserName || "-";
			case 'regionID':
				return regions.find((r) => r.RID === connection.regionID)?.Rgn || '-';
			case 'taxID':
				return connection.taxID || "-";
			case 'source':
				return connection.source || "-";
			case 'city':
				return connection.city || "-";
			case 'state':
				return connection.state || "-";
			case 'country':
				return connection.country || "-";
			case 'mobile':
				return connection.mobile || "-";
			case 'email':
				return connection.email || "-";
			case 'feedback':
				return connection.sentiment || "-";
			case 'segment':
				return connection.segment || "-";
			case 'tags':
				return connection.tags || "-";
			default:
				// Handle dynamic thread/custom fields starting with specific prefixes
				if (key.startsWith('cntIn') || key.startsWith('cntOut') || key.startsWith('customField_')) {
					return connection[key] || 0;
				}
				return connection[key] || "-";
		}
	};

	const WebdataTable = () => {
		return (
			<>
				<Card className="bg-sahi-white hidden lg:block !pt-0">
					<CardContent className="px-0 !sahi-radius">
						{/* Wrapper div with horizontal scroll */}
						<div className="overflow-x-auto overflow-y-hidden">
							<Table className="min-w-full table-auto" isOverflowAuto={false}>
								<TableHeader>
									<TableRow className="bg-sahi-white py-1.5 h-11">
										{isBulkAllowed && (<TableHead
											className={cn(
												"table-header-text whitespace-nowrap align-top text-left pl-4 bg-sahi-white z-10")}
										></TableHead>)}
										{tableHeaderCols
											?.filter(col => {
												// Always show dynamic columns
												if (col.key.startsWith('cntIn') ||
													col.key.startsWith('cntOut') ||
													col.key.startsWith('customField_') ||
													col.key === 'activity') {
													return true;
												}
												// Show base columns based on preferences
												return columnVisibility[col.key] === true;
											})
											.map(({ key, label, className = '', style = {} }) => (
												<TableHead
													key={key}
													className={`font-semibold text-sm text-black whitespace-nowrap uniform-spacing ${key == 'bizName' && hasAnySegments ? 'px-8' : ''} `}
													style={style}
													onClick={() => sortData(key)}
												>
													<div className={`flex items-center cursor-pointer ${className}`}>
														{label}
														{sortConfig.key === key && sortConfig.direction && (
															sortConfig.direction === 'asc' ? (
																<ArrowUp className="ml-1 h-4 w-4 text-black" />
															) : (
																<ArrowDown className="ml-1 h-4 w-4 text-black" />
															)
														)}
													</div>
												</TableHead>
											))}
										<TableHead
											className={cn(
												"table-header-text whitespace-nowrap align-top text-left pl-4 bg-sahi-white z-10"
											)}
										>
										</TableHead>
									</TableRow>
								</TableHeader>
								<TableBody>
									{currentConnections.map((connection, index) => {
										const lastFeedbackDT = connection?.lastFdbkReqDT ? new Date(connection.lastFdbkReqDT) : null;
										const isFeedbackSentToday = lastFeedbackDT && isSameDay(lastFeedbackDT, new Date());
										return (
											<TableRow
												key={connection.connID || index}
												onClick={() => handleRowClick(connection)}
												className="hover:bg-gray-50 cursor-pointer"
											>
												{isBulkAllowed && (<TableCell
													className="uniform-spacing pl-4 translate-y-0.5 cursor-pointer"
													onClick={(e) => {
														e.stopPropagation();
														handleCheckboxChange(connection.connID);
													}}
													onDoubleClick={(e) => e.stopPropagation()}
												>
													<Checkbox
														checked={selectedConnIDs.includes(connection.connID)}
														onCheckedChange={() => handleCheckboxChange(connection.connID)}
														onClick={(e) => e.stopPropagation()}
													/>
												</TableCell>)}

												{tableHeaderCols
													?.filter(col => {
														// Always show dynamic columns
														if (col.key.startsWith('cntIn') ||
															col.key.startsWith('cntOut') ||
															col.key.startsWith('customField_') ||
															col.key === 'activity') {
															return true;
														}
														// Show base columns based on preferences
														return columnVisibility[col.key] === true;
													})
													.map((col) => {
														// Business Name
														if (col.key === 'bizName') {
															return (
																<TableCell
																	key={col.key}
																	className={`uniform-spacing ${isBulkAllowed ? 'pl-2' : 'pl-4'} whitespace-nowrap`}
																>
																	<div className="flex items-center gap-2">
																		{hasAnySegments && (
																			connection.segmentColor ? (
																				<div
																					className="w-2.5 h-2.5 rounded-full flex-shrink-0"
																					style={{ backgroundColor: connection.segmentColor }}
																				/>
																			) : (
																				<div className="w-2.5 h-2.5 flex-shrink-0" />
																			)
																		)}
																		<span className="font-medium text-text-color">
																			{connection.bizName || '-'}
																		</span>
																	</div>
																</TableCell>
															);
														}

														// Contact Name
														if (col.key === 'contactName') {
															return (
																<TableCell key={col.key} className="uniform-spacing pl-4 whitespace-nowrap">
																	<span className="text-text-color">
																		{connection.contactName || '-'}
																	</span>
																</TableCell>
															);
														}
														if (col.key === 'feedback') {
															return (
																<TableCell key={col.key} className="uniform-spacing pl-4 whitespace-nowrap"
																>
																	{connection.connTypes.includes('C') ?
																		<HoverCard>
																			<HoverCardTrigger asChild>
																				<div
																					{...((!isFeedbackSentToday && canDeleteConnections && canCreateConnections && canEditConnections === 1)
																						? {
																							onClick: (e) => { handleSentimentClick(e, connection) }
																						}
																						: {})}
																				>
																					<span className="font-semibold text-gray-900">
																						{sentimentEmoji(connection.fdbkScore)}
																					</span>
																				</div>
																			</HoverCardTrigger>

																			<HoverCardContent className="bg-sahi-primary-color sahi-radius shadow-2xl p-3 w-auto text-left" side="top">
																				<p className="italic text-sahi-white text-sm">
																					{isFeedbackSentToday
																						? "You've already sent a sentiment request today."
																						: lastFeedbackDT
																							? `Last requested on ${format(lastFeedbackDT, "dd-MMM-yy")}`
																							: "Click to send a sentiment request."}
																				</p>
																			</HoverCardContent>
																		</HoverCard>
																		: '-'}
																</TableCell>
															);
														}

														// Potential
														if (col.key === 'potential') {
															return (
																<TableCell key={col.key} className="text-right uniform-spacing pr-6 w-[120px] whitespace-nowrap">
																	{connection.potential ? (
																		<span className="text-text-color">
																			<FormatAmount
																				amount={connection.potential}
																				currency={currencySymbol}
																				showCurr={false}
																			/>
																		</span>
																	) : (
																		<span className="text-text-color">-</span>
																	)}
																</TableCell>
															);
														}

														// Activity or Dynamic Thread Columns
														if (col.key === 'activity' || col.key.startsWith('cntIn') || col.key.startsWith('cntOut')) {
															return (
																<TableCell
																	key={col.key}
																	className={cn('text-text-color uniform-spacing text-right !px-4 whitespace-nowrap')}
																	style={col.style}
																>
																	{col.key === 'activity'
																		? (() => {
																			// Calculate total activity by summing all thread counts
																			let totalActivity = 0;
																			threadType.forEach(tt => {
																				if (tt.Flow === 'In') {
																					totalActivity += connection[`cntIn${tt.Sn}Open`] || 0;
																				} else if (tt.Flow === 'Out') {
																					totalActivity += connection[`cntOut${tt.Sn}Open`] || 0;
																				}
																			});
																			return totalActivity === 0 ? '-' : totalActivity;
																		})()
																		: connection[col.key] === 0
																			? '-'
																			: connection[col.key]}
																</TableCell>
															);
														}

														// Since
														if (col.key === 'sinceDT') {
															return (
																<TableCell key={col.key} className="text-text-color uniform-spacing pl-2 whitespace-nowrap">
																	<span className="pl-4">{connection.sinceDTF}</span>
																</TableCell>
															);
														}

														// Last Contacted
														if (col.key === 'lastRecDT') {
															return (
																<TableCell key={col.key} className="text-text-color uniform-spacing whitespace-nowrap">
																	<Tooltip>
																		<TooltipTrigger asChild>
																			<span
																				style={{ color: connection.lastRecDTColor }}
																				className="pl-2"
																			>
																				{connection.lastRecDTF || '-'}
																			</span>
																		</TooltipTrigger>
																		<TooltipContent className="bg-black text-white sahi-radius px-2 py-1 text-sm">
																			<p>{connection.lastRecDT ? format(new Date(connection.lastRecDT), 'hh:mm a') : ''}</p>
																		</TooltipContent>
																	</Tooltip>
																</TableCell>
															);
														}

														// Next Action
														if (col.key === 'nextTaskDT') {
															return (
																<TableCell key={col.key} className="text-text-color uniform-spacing whitespace-nowrap">
																	<Tooltip>
																		<TooltipTrigger asChild>
																			<span>
																				<span className="pl-2" style={{ color: connection.nextTaskDTColor }}>
																					{connection.nextTaskDTF || '-'}
																				</span>
																				{connection.nextTaskTyp ? ` - ${connection.nextTaskTyp}` : ''}
																			</span>
																		</TooltipTrigger>
																		<TooltipContent className="bg-black text-white sahi-radius px-2 py-1 text-sm">
																			<p>{connection.nextTaskDT ? format(new Date(connection.nextTaskDT), 'hh:mm a') : ''}</p>
																		</TooltipContent>
																	</Tooltip>
																</TableCell>
															);
														}

														// Custom Fields
														if (col.key.startsWith('customField_')) {
															return (
																<TableCell key={col.key} className="text-text-color uniform-spacing pl-4 text-left whitespace-nowrap">
																	<span className="text-sm">{connection[col.key] || '-'}</span>
																</TableCell>
															);
														}

														// Executive
														if (col.key === 'pocUserID') {
															return (
																<TableCell key={col.key} className="text-text-color uniform-spacing pl-4 whitespace-nowrap">
																	{connection.pocUserName || '-'}
																</TableCell>
															);
														}

														if (col.key === 'source') {
															return (
																<TableCell key={col.key} className="text-text-color uniform-spacing pl-4 whitespace-nowrap">
																	{connection.source || '-'}
																</TableCell>
															);
														}

														if (col.key === 'city') {
															return (
																<TableCell key={col.key} className="text-text-color uniform-spacing pl-4 whitespace-nowrap">
																	{connection.city || '-'}
																</TableCell>
															);
														}

														if (col.key === 'state') {
															return (
																<TableCell key={col.key} className="text-text-color uniform-spacing pl-4 whitespace-nowrap">
																	{connection.state || '-'}
																</TableCell>
															);
														}

														if (col.key === 'taxID') {
															return (
																<TableCell key={col.key} className="text-text-color uniform-spacing pl-4 whitespace-nowrap">
																	{connection.taxID || '-'}
																</TableCell>
															);
														}

														if (col.key === 'country') {
															return (
																<TableCell key={col.key} className="text-text-color uniform-spacing pl-4 whitespace-nowrap">
																	{connection.country || '-'}
																</TableCell>
															);
														}

														if (col.key === 'mobile') {
															return (
																<TableCell key={col.key} className="text-text-color uniform-spacing pl-4 whitespace-nowrap">
																	{connection.mobile || '-'}
																</TableCell>
															);
														}

														if (col.key === 'email') {
															return (
																<TableCell key={col.key} className="text-text-color uniform-spacing pl-4 whitespace-nowrap">
																	{connection.email || '-'}
																</TableCell>
															);
														}

														if (col.key === 'segment') {
															return (
																<TableCell key={col.key} className="text-text-color uniform-spacing pl-4 whitespace-nowrap">
																	{connection.segment || '-'}
																</TableCell>
															);
														}

														if (col.key === 'tags') {
															return (
																<TableCell key={col.key} className="text-text-color uniform-spacing pl-4 whitespace-nowrap">
																	{connection.tags ? (
																		<div className="flex flex-wrap gap-1">
																			{connection.tags.split(",").map((tag, index) => {
																				const trimmedTag = tag.trim();
																				if (!trimmedTag) return null;

																				return (
																					<span
																						key={index}
																						className="inline-block px-2 py-1 text-xs font-medium bg-gray-100 sahi-radius"
																					>
																						#{trimmedTag}
																					</span>
																				);
																			})}
																		</div>
																	) : (
																		'-'
																	)}
																</TableCell>
															);
														}

														// Region
														if (col.key === 'regionID') {
															return (
																<TableCell key={col.key} className="text-text-color uniform-spacing pl-4 whitespace-nowrap">
																	{regions.find((r) => r.RID === connection.regionID)?.Rgn || '-'}
																</TableCell>
															);
														}

														// Default fallback for any other columns
														return (
															<TableCell key={col.key} className="text-text-color uniform-spacing pl-4 whitespace-nowrap">
																{connection[col.key] || '-'}
															</TableCell>
														);
													})}

												{/* Actions Column - Sticky on the right */}
												<TableCell className="text-left flex justify-end items-center px-2 pr-4 bg-white hover:bg-gray-50 z-10">
													<ContactActions connectionData={connection} showTemplate={connection?.connTypes.includes('C') ? true : false} connID={connection.connID} />
												</TableCell>
											</TableRow>
										)
									})}
								</TableBody>
							</Table>
						</div>
					</CardContent>
				</Card>
				<Pagination
					currentPage={currentPage}
					totalPages={totalPages}
					rowsPerPage={rowsPerPage}
					onRowsPerPageChange={(size) => setRowsPerPage(size)}
					onPageChange={(page) => setCurrentPage(page)}
				/>
			</>
		)
	}

	const currentConnections = useMemo(() => {
		if (filteredConnections.length === 0) return [];

		let sorted = [];
		if (!sortConfig.key) {
			sorted = [...filteredConnections].sort((a, b) => {

				if (!isMobile) {
					return (a.bizName || '').toLowerCase().localeCompare((b.bizName || '').toLowerCase());
				}

				const nameA = (a.bizName && a.bizName !== '-') ? a.bizName : (a.contactName || '');
				const nameB = (b.bizName && b.bizName !== '-') ? b.bizName : (b.contactName || '');
				return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
			});
		} else {
			sorted = [...filteredConnections];
		}

		if (!isMobile) {
			const sliced = sorted.slice(startIndex, endIndex);
			return sliced.length > 0 ? sliced : sorted;
		} else {
			return sorted;
		}
	}, [filteredConnections, sortConfig.key, sortConfig.direction, startIndex, endIndex, isMobile]);

	const hasAnySegments = useMemo(() => {
		return currentConnections.some(conn => conn.segmentColor);
	}, [currentConnections]);

	// if (loading && !isTemplateDialogActive) {
	// 	return (
	// 		<div className="flex items-center justify-center h-96">
	// 			<Loader2 className="h-8 w-8 animate-spin text-sahi-primary-color mr-3" />
	// 			<span className="text-text-color">Loading {connTypeInfo.label.toLowerCase()}...</span>
	// 		</div>
	// 	);
	// }

	if (error) {
		return (
			<div className="p-6">
				<Card className="border-sahi-red bg-red-50">
					<CardContent className="p-4">
						<p className="text-sahi-red font-medium">{error}</p>
					</CardContent>
				</Card>
			</div>
		);
	}

	const SentimentCountBoxes = () => {
		// Hidden for now as requested
		return null;

		const hasAnyCounts = sentimentCounts.happy > 0 || sentimentCounts.unhappy > 0 || sentimentCounts.unknown > 0;

		if (!hasAnyCounts) return null;

		const handleSentimentClick = (type) => {
			if (activeSentimentFilter === type) {
				// If clicking the same filter, deactivate it
				setActiveSentimentFilter(null);
			} else {
				// Activate the clicked filter
				setActiveSentimentFilter(type);
			}
			setCurrentPage(1); // Reset to first page
		};

		return (
			<div className="flex items-center gap-2 flex-wrap justify-end">
				{(
					<div
						onClick={() => handleSentimentClick('happy')}
						className={cn(
							"flex items-center px-3 lg:px-4 h-8 lg:h-10 cursor-pointer transition-all",
							"w-fit max-w-[240px] rounded border shadow-sm",
							activeSentimentFilter === 'happy'
								? "bg-sahi-green text-white border-sahi-green"
								: "bg-white text-black filter-border hover:bg-gray-50"
						)}
					>
						<Smile className={`w-4 h-4 mr-2 ${activeSentimentFilter !== 'happy' ? 'text-sahi-green' : ''}`} />
						<span className="f-row gap-1 whitespace-nowrap text-xs lg:text-sm">
							<span>Happy: </span>
							<span className="font-medium">{sentimentCounts.happy}</span>
						</span>
					</div>
				)}

				{(
					<div
						onClick={() => handleSentimentClick('unhappy')}
						className={cn(
							"flex items-center px-3 lg:px-4 h-8 lg:h-10 cursor-pointer transition-all",
							"w-fit max-w-[240px] rounded border shadow-sm",
							activeSentimentFilter === 'unhappy'
								? "bg-sahi-red text-white border-sahi-red"
								: "bg-white text-black filter-border hover:bg-gray-50"
						)}
					>
						<Frown className={`w-4 h-4 mr-2 text ${activeSentimentFilter !== 'unhappy' ? 'text-sahi-red' : ''}`} />
						<span className="f-row gap-1 whitespace-nowrap text-xs lg:text-sm">
							<span>Unhappy: </span>
							<span className="font-medium">{sentimentCounts.unhappy}</span>
						</span>
					</div>
				)}

				{(
					<div
						onClick={() => handleSentimentClick('unknown')}
						className={cn(
							"flex items-center px-3 lg:px-4 h-8 lg:h-10 cursor-pointer transition-all",
							"w-fit max-w-[240px] rounded border shadow-sm",
							activeSentimentFilter === 'unknown'
								? "bg-sahi-dark-blue text-white border-gray-500"
								: "bg-white text-black filter-border hover:bg-gray-50"
						)}
					>
						<MehIcon className={`w-4 h-4 mr-2 ${activeSentimentFilter !== 'unknown' ? 'text-sahi-dark-blue' : ''}`} />
						<span className="f-row gap-1 whitespace-nowrap text-xs lg:text-sm">
							<span>Unknown: </span>
							<span className="font-medium">{sentimentCounts.unknown}</span>
						</span>
					</div>
				)}
			</div>
		);
	};

	return (
		<TooltipProvider>
			<div className={`${embedded ? 'space-y-1' : 'space-y-3 lg:space-y-6'} max-w-full`}>

				{/* Header */}
				{!isMobile ? (
					<div className="hidden lg:block">
						<div className="flex justify-between items-center gap-3">
							<div className="flex items-center flex-grow">
								<div className="flex flex-col mr-4">
									{/* Search for this line in your JSX (around line 1250) */}
									<h1 className="text-3xl font-bold text-text-color web-header-name">
										{new URLSearchParams(location.search).has('na') || new URLSearchParams(location.search).has('NA')
											? "Lost Customers"
											: "Contacts"}
									</h1>									{/* <span className="text-xs mt-1 text-gray-600 leading-relaxed whitespace-nowrap">Manage the people and companies you interact with.</span> */}
								</div>
								<div className="flex items-center justify-end flex-grow gap-3">
									<SentimentCountBoxes />
									{connectionData.length > 0 && (
										<div className="flex items-center gap-3">
											{/* Cold Contacts Box */}
											{coldConnections.length > 0 && (
												<div
													onClick={() => {
														if (showColdContactsOnly) {
															setSelectedFilters((prev) => ({ ...prev, contactCategory: 'all' }));
															setTempFilters((prev) => ({ ...prev, contactCategory: 'all' }));
															setShowColdContactsOnly(false);
															setShowNormalContactsOnly(true);
														} else {
															setSelectedFilters((prev) => ({ ...prev, contactCategory: 'cold' }));
															setTempFilters((prev) => ({ ...prev, contactCategory: 'cold' }));
															setShowColdContactsOnly(true);
															setShowNormalContactsOnly(false);
														}
														setCurrentPage(1);
													}}
													className={cn(
														"flex items-center px-3 lg:px-4 h-8 lg:h-10",
														"w-fit max-w-[240px] bg-white text-black rounded-lg border shadow-sm cursor-pointer",
														showColdContactsOnly
															? "filter-border bg-sahi-blue-light text-sahi-black"
															: "border-gray-300 filter-border"
													)}
												>
													<span className="f-row gap-1 whitespace-nowrap text-xs lg:text-sm">
														<span>Cold: </span>
														<span className="font-medium">{coldConnections.length}</span>
														<span className="text-gray-500 mx-1">|</span>
														<span>Due: </span>
														<span className="font-medium">{coldContactsDueData.dueTodayCount}</span>
													</span>
												</div>)}
											<div
												onClick={() => {
													setShowColdContactsOnly(false);
													setShowNormalContactsOnly(true);
													setSelectedFilters((prev) => ({
														...prev,
														contactCategory: 'all'
													}));
													setCurrentPage(1);
												}}
												className={cn(
													"flex items-center px-3 lg:px-4 h-8 lg:h-10",
													"w-fit max-w-[240px] bg-white text-black rounded-lg border filter-border shadow-sm cursor-pointer"
												)}
											>
												<span className="f-row gap-1 whitespace-nowrap text-xs lg:text-sm">
													<span>Total: </span>
													<span className="font-medium">{connections.length}</span>
												</span>
											</div>

											<div className="relative w-120 sahi-radius filter-border">
												<Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-dropdown-white" />
												<Input
													placeholder="Search"
													value={searchTerm}
													onChange={(e) => {
														setSearchTerm(e.target.value);
													}}
													className="pl-10 h-10 border-none focus:outline-none focus:ring-0 shadow-none" />
											</div>
										</div>
									)}
								</div>
							</div>
							<div className="flex items-center gap-3">
								{isAgencyAuthorized && (
									<Button
										variant="outline"
										className="button-config text-base sahi-primary-button py-[6px] px-[10px]"
										onClick={() => {

											navigate('/activity');
										}}
									>
										<div className="flex items-center cursor-pointer">
											<Activity className="h-4 w-4 mr-2" />
											Activity
										</div>
									</Button>
								)}

								{filteredConnections.length > 0 && <ColumnPreferencesDropdown
									type="CONN"
									columns={baseTableHeaderCols} // Pass only base columns, not tableHeaderCols
									hideColumns={columnPrefsHideChks}
									columnVisibility={columnVisibility}
									onUpdate={(newColumnVisibility) => {
										setColumnVisibility(newColumnVisibility);
									}}
								/>}

								{canAddConnections && (
									<Button
										onClick={() => setIsConnectionDialogOpen(true)}
										className="button-config text-base sahi-primary-button flex items-center py-[6px] px-[10px]"
									>
										<Plus className="h-4 w-4" />
										Add {connTypeInfo.singular}
									</Button>
								)}

								{selectedConnIDs.length > 0 && isBulkAllowed && (
									<Button
										className="button-config text-base sahi-primary-button flex items-center py-[6px] px-[10px]"
										onClick={() => setBulkWhatsAppDialogOpen(true)}
									>
										<BsWhatsapp className="h-4 w-4" />
										Bulk
									</Button>
								)}

								{canAddConnections && canShowImportInquiries() && (
									<Button
										className="button-config text-base sahi-primary-button py-[6px] px-[10px]"
										onClick={() => setOpenConnectionModal(true)}
									>
										<div className="flex items-center cursor-pointer">
											<Download className="h-4 w-4 mr-2" />
											Import
										</div>
									</Button>
								)}


								{openConnectionModal && (
									<ImportExcel
										open={openConnectionModal}
										onClose={() => setOpenConnectionModal(false)}
									/>
								)}

								{filteredConnections.length > 0 && agencyData?.EnblExcelExport && agencyData?.SubTypeID > 1 && isAdmin && (
									<Button
										onClick={handleExportToExcel}
										className="button-config sahi-primary-button flex items-center py-[6px] px-[10px]"
									>
										<FaFileExcel className="h-4 w-4 mx-1" />
									</Button>
								)}

								{connectionData.length > 0 && (
									filterButton
								)}
							</div>
						</div>
					</div>
				) : (
					<div className={cn("flex flex-col lg:hidden gap-3", embedded ? "pt-0" : "pt-3")}>
						{!embedded && connectionData.length > 0 && (
							<div className="w-full flex items-center gap-2">
								<div className="relative flex-grow">
									<Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-dropdown-white" />
									<Input
										value={searchTerm}
										placeholder="Search"
										onChange={(e) => {
											setSearchTerm(e.target.value);
										}}
										className="pl-10 h-10 w-full"
									/>
								</div>
								{filterButton}
							</div>
						)}
						<SentimentCountBoxes />
						{openConnectionModal && (
							<ImportExcel
								open={openConnectionModal}
								onClose={() => setOpenConnectionModal(false)}
							/>
						)}
					</div>
				)}

				{/* Connection Type Filter and Other Filters */}
				{connectionData && (
					<>
						{isFilterSelected && !isMobile && (
							<div className="flex flex-col gap-4 mb-4">
								<div className="flex flex-wrap gap-4">
									{filterOptions
										.filter(({ key }) => !['lastContact', 'notContacted', 'nextTask', 'lastActivity', 'noActivity'].includes(key))
										.map((filterOption) => {
											const { key, label, options, displayValue, renderOption, disabled, searchEnabled, type, categories } = filterOption;

											// Use CommonFilter for list type
											if (type === 'list') {
												return (
													<CommonFilter
														key={key}
														label={label}
														options={options}
														categories={categories}
														value={selectedFilters[key]}
														displayValue={displayValue}
														onChange={(val) => {
															setSelectedFilters((prev) => {
																const newFilters = { ...prev, [key]: val };
																if (key === 'contactCategory' && val !== 'InactiveCustomer') {
																	newFilters.noActivity = 'all';
																}
																return newFilters;
															});
															setTempFilters((prev) => {
																const newFilters = { ...prev, [key]: val };
																if (key === 'contactCategory' && val !== 'InactiveCustomer') {
																	newFilters.noActivity = 'all';
																}
																return newFilters;
															});
															if (key === 'contactCategory' && val === 'cold') {
																setShowColdContactsOnly(true);
																setShowNormalContactsOnly(false);
															} else if (key === 'contactCategory' && (val === 'all' || val === 'regular' || val === 'FutureProspect' || val === 'CurrentCustomer' || val === 'InactiveCustomer' || val === 'Supplier' || val === 'Other')) {
																setShowColdContactsOnly(false);
																setShowNormalContactsOnly(true);
															}
														}}
														disabled={disabled}
														showClearButton={true}
														isMobileDropdown={false}
													/>
												);
											}

											return (
												<CommonFilter
													key={key}
													label={label}
													options={options}
													value={selectedFilters[key]}
													onChange={(val) => {
														setSelectedFilters((prev) => ({ ...prev, [key]: val }));
														setTempFilters((prev) => ({ ...prev, [key]: val }));
													}}
													displayValue={displayValue}
													disabled={disabled}
													renderOption={renderOption}
													searchEnabled={searchEnabled}
												/>
											);
										})}
								</div>

								<div className="flex flex-wrap gap-4 pt-2">
									{filterOptions
										.filter(({ key }) => ['lastContact', 'notContacted', 'nextTask', 'lastActivity', 'noActivity'].includes(key))
										.map(({ key, label, options, displayValue, renderOption, disabled, searchEnabled }) => (
											<CommonFilter
												key={key}
												label={label}
												options={options}
												value={selectedFilters[key]}
												onChange={(val) => {
													setSelectedFilters((prev) => {
														const newFilters = { ...prev, [key]: val };
														if (key === 'noActivity' && val !== 'all') {
															newFilters.contactCategory = 'InactiveCustomer';
														}
														return newFilters;
													});
													setTempFilters((prev) => {
														const newFilters = { ...prev, [key]: val };
														if (key === 'noActivity' && val !== 'all') {
															newFilters.contactCategory = 'InactiveCustomer';
														}
														return newFilters;
													});
												}}
												displayValue={displayValue}
												disabled={disabled}
												renderOption={renderOption}
												searchEnabled={searchEnabled}
											/>
										))}
								</div>
							</div>
						)}

						{(connectionData.length === 0 || filteredConnections.length === 0) && !isInitLoading && (
							<div className="f-col items-start gap-3 mt-0">
								<p className="no-records">
									<span>
										{showColdContactsOnly
											? "No cold contacts found."
											: `No ${connTypeInfo.label.toLowerCase()} found${hasActiveFilters && connectionData.length > 0 ? ' for selected filters.' : '.'}`
										}
									</span>
									{(hasActiveFilters || showColdContactsOnly) && connectionData.length > 0 && (
										<span
											onClick={handleResetFilters}
											className="text-sahi-primary-color underline hover:text-sahi-primary-color/80 cursor-pointer ml-2"
										>
											Clear filter.
										</span>
									)}
								</p>
								{canAddConnections && (
									<Button
										onClick={() => setIsConnectionDialogOpen(true)}
										className={`button-config ${isMobile ? '' : 'text-base'} sahi-primary-button flex items-center py-[6px] px-2 mt-2`}
									>
										<Plus className="h-4 w-4" />
										Add {connTypeInfo.singular}
									</Button>
								)}
							</div>
						)}
					</>
				)}

				{isFilterSelected && isMobile && (
					<Drawer
						open={isDrawerOpen}
						onOpenChange={(open) => {
							setIsDrawerOpen(open);
							if (!open) {
								setIsFilterSelected(false);
							}
						}}
					>
						<DrawerContent className="p-0 [&>div:first-child]:hidden ">
							<div className="f-col h-[100dvh] !rounded-t-[10px]">
								<div className="flex plain items-center justify-between p-4 border-b-2 border-gray-200 text-xl !rounded-t-[10px]">
									<div className="flex gap-4 items-center ">
										<DrawerClose tabIndex={-1} className="p-0 w-auto h-auto flex-shrink-0 flex justify-center">
											<ArrowLeft className="h-[24px] w-[24px]" onClick={() => {
												setIsDrawerOpen(false);
												setIsFilterSelected(false);
											}} />
											<span className="sr-only">Back</span>
										</DrawerClose>
										<p className="text-lg font-semibold text-sahi-primary-color">Contact Filters</p>
									</div>
									<button
										className="group flex items-center gap-1 text-sm font-light hover:underline transition duration-200 text-sahi-primary-color"
										onClick={handleResetFilters}
									>
										<RiResetLeftFill className="group-hover:rotate-[-20deg] transition-transform duration-200" />
										<span>Reset</span>
									</button>
								</div>
								<div className="flex flex-1 overflow-y-auto">
									<div className="flex-1 p-3 overflow-y-auto filter-scroll-container">
										{filterOptions.map(({ key, label, options, displayValue, type, mobileDropdownText, showAllOption, MobileLabel, mobileNoLabel, disabled, allText, allID, prependOnlyName, categories }) => {
											if (key === 'region' && !regions?.length) return;

											// Use CommonFilter for list type (contactCategory)
											if (type === 'list' && key === 'contactCategory') {
												return (
													<div key={key} id={key} className="mb-4">
														<CommonFilter
															key={key}
															label={label}
															options={options}
															categories={categories}
															value={tempFilters[key]}
															displayValue={displayValue}
															onChange={(value) => {
																setTempFilters((prev) => {
																	const newFilters = { ...prev, [key]: value };
																	if (key === 'contactCategory' && value !== 'InactiveCustomer') {
																		newFilters.noActivity = 'all';
																	}
																	return newFilters;
																});
																// Auto-set showColdContactsOnly when 'cold' is selected in mobile
																if (key === 'contactCategory' && value === 'cold') {
																	setShowColdContactsOnly(true);
																	setShowNormalContactsOnly(false);
																} else if (key === 'contactCategory' && (value === 'all' || value === 'regular' || value === 'FutureProspect' || value === 'CurrentCustomer' || value === 'InactiveCustomer' || value === 'Supplier' || value === 'Other')) {
																	setShowColdContactsOnly(false);
																	setShowNormalContactsOnly(true);
																}
															}}
															disabled={disabled}
															showClearButton={true}
															isMobileDropdown={true}
															mobileDropdownText={mobileDropdownText}
															mobileLabel={MobileLabel}
														/>
													</div>
												);
											}

											return (
												<div key={key} id={key} className="mb-4">
													<DrawerFilter
														key={key}
														id={key}
														label={label}
														options={key === 'segment' ? options.map((seg) => (seg.CNm)) : options}
														value={tempFilters[key]}
														displayValue={displayValue}
														onChange={(value) => {
															setTempFilters((prev) => {
																const newFilters = { ...prev, [key]: value };
																if (key === 'noActivity' && value !== 'all') {
																	newFilters.contactCategory = 'InactiveCustomer';
																}
																return newFilters;
															});
														}}
														disabled={disabled}
														showAllOption={showAllOption}
														MobileLabel={MobileLabel}
														sortConfig={sortConfig}
														setTempsortConfig={setTempsortConfig}
														tempsortConfig={tempsortConfig}
														sortOptionMap={mobileSortMap}
														type={type}
														mobileDropdownText={mobileDropdownText}
														mobileNoLabel={mobileNoLabel}
														allText={allText}
														allID={allID}
														prependOnlyName={prependOnlyName}
													/>
												</div>
											)
										})}
									</div>
								</div>
								<DrawerFooter className="sticky bottom-0 border-t-2 p-3 bg-sahi-white">
									<DrawerClose>
										<div className="f-row justify-start gap-2">
											<Button
												className="sahi-primary-button"
												onClick={() => {
													// Apply purely via in-memory state - deliberately not touching the
													// URL here. Rewriting the URL on Apply used to be undone by the
													// modal-close history cleanup (ModalStackManager pops a history
													// entry ~150ms after the drawer closes), which silently reverted
													// the filters. Not navigating sidesteps that whole class of bug.
													// Deep links (e.g. /connections?na=4 from the dashboard) still work
													// on initial load via the location.search-driven effect above.
													setSelectedFilters(tempFilters);
													setIsDrawerOpen(false);
													setIsFilterSelected(false);
													setSortConfig(tempsortConfig);
												}}
											>
												Apply
											</Button>
											<Button
												variant="outline"
												className="sahi-secondary-button"
												onClick={handleCancel}
											>
												Cancel
											</Button>
										</div>
									</DrawerClose>
								</DrawerFooter>
							</div>
						</DrawerContent>
					</Drawer>
				)}

				{/* Table and Mobile Cards */}
				{(() => {
					return (connectionData.length > 0 && filteredConnections.length > 0) ? (
						<>
							{!isMobile ? (
								<WebdataTable />
							) : (
								<div>
									{Array.isArray(currentConnections) && currentConnections.length > 0 ? (
										<div className="space-y-2">
											{currentConnections.map(renderMobileCard)}
										</div>
									) : (
										<div className="text-center py-8 text-gray-500">
											No connections to display
										</div>
									)}

									{currentConnections.length <= 4 && canAddConnections && (
										<div className="sahi-radius p-[0px_0px_6px] w-full flex flex-col justify-center items-center mt-2">
											<Button
												className="button-config sahi-primary-button flex items-center py-[6px] px-[10px] w-full"
												onClick={() => setIsConnectionDialogOpen(true)}
											>
												<Plus className="h-4 w-4" />
												Add {connTypeInfo.singular}
											</Button>
										</div>
									)}
								</div>
							)}
						</>
					) : (
						<div className="text-center py-8 text-gray-500">
							No {connTypeInfo.label.toLowerCase()} found.
						</div>
					);
				})()}
				<ConnectionEntryDialog
					open={isConnectionDialogOpen}
					onOpenChange={setIsConnectionDialogOpen}
					triggerButton={false}
					initialConnType={connTypeInfo.singular}
					onConnectionAdded={(savedConnection) => {
						// This sets the newly added connection as selected in the form
						if (savedConnection) {
							// setSelectedConnection(savedConnection)
							setIsDetailOpen(true)
						}
					}}
				/>
				{selectedConnection && (
					<ConnectionDetailsWrapper
						isOpen={isDetailOpen}
						onClose={handleDetailClose}
						connID={selectedConnection.connID}
					/>
				)}

				<TemplateDialog
					isOpen={templateDialogOpen}
					onClose={() => {
						setTemplateDialogOpen(false);
						setIsTemplateDialogActive(false);
					}}
					connectionData={templateDialogData}
					onRecordAdded={null}
					connID={connectionData.connID}
				/>

				{isWspDialogOpen && selectedConnectionForWsp && (
					<WspDialog
						isOpen={isWspDialogOpen}
						onClose={() => {
							setIsWspDialogOpen(false);
							setSelectedConnectionForWsp(null);
						}}
						connectionData={{
							connID: selectedConnectionForWsp.connID,
							contactName: selectedConnectionForWsp.contactName,
							bizName: selectedConnectionForWsp.bizName,
							cc: selectedConnectionForWsp.cc
						}}
						phone={selectedConnectionForWsp.mobile || ''}
						type='contact'
					/>
				)}

				<BulkWhatsAppDialog
					isOpen={bulkWhatsAppDialogOpen}
					onClose={setBulkWhatsAppDialogOpen}
					threadData={selectedConnectionsData} // Ensure it receives the array of connections
					selectedThreadCount={selectedConnIDs.length}
					isBulkMessage={true}
				/>

				<AlertBox
					open={fdbkReqState.openDialog}
					onOpenChange={(open) =>
						setFdbkReqState((prev) => ({ ...prev, openDialog: open }))
					}
					title="Request Sentiment"
					content={
						<div>
							<p className="mb-1">Would you like to ask {fdbkReqState.connBizName || fdbkReqState.connContactName || ''} how their experience is as your customer?</p>
						</div>
					}
					className={isDesktop ? "w-[400px]" : ""}
					actions={[
						{
							label: "No",
							variant: "cancel",
							value: 0,
							className: "w-full sm:w-auto",
							icon: <X className="h-4 w-4" />,
						},
						{
							label: "Yes",
							variant: "action",
							value: 1,
							className: "w-full sm:w-auto",
							icon: <Check className="h-4 w-4" />,
						},
					]
					}
					onAction={(actionValue) => {
						if (actionValue === 1) {
							handleFdbkRequest();
						} else if (actionValue === 0) {
							setFdbkReqState(dfltFdbkReqObj);
						}
					}}
				/>

				{/* Select Interaction Type Drawer*/}
				<Drawer
					open={openRecordTypeDropdown}
					onOpenChange={(open) => {
						setOpenRecordTypeDropdown(open);
						if (!open) {
							setRecordTypeView('list');
							setNewRecordTypeName('');
						}
					}}
				>
					<DrawerContent
						className="p-0 [&>div:first-child]:hidden top-auto rounded-t-[22px] overflow-hidden bg-background"
						style={{
							maxHeight: '85vh',
							height: 'auto'
						}}
					>
						<div className="flex flex-col" style={{ maxHeight: '85vh' }}>
							{recordTypeView === 'add' ? (
								<>
									<div className="flex items-center justify-between px-4 h-16 shrink-0">
										<div className="flex gap-4 items-center">
											<button
												type="button"
												tabIndex={-1}
												onClick={() => {
													setRecordTypeView('list');
													setNewRecordTypeName('');
												}}
												className="p-0 w-auto h-auto flex-shrink-0 flex justify-center text-gray-500 hover:text-gray-700 cursor-pointer"
											>
												<ArrowLeft className="h-[24px] w-[24px]" />
											</button>
											<p className="text-lg font-semibold text-gray-900">New Type</p>
										</div>
									</div>
									<div className="overflow-y-auto custom-scroll flex-1 px-4 pb-4 pt-3 flex flex-col gap-4">
										<div className="flex flex-col gap-1.5">
											<div className="flex items-center justify-between">
												<span className="text-sm font-medium text-gray-700">Name</span>
												<span className="text-[11px] text-sub-text-color">{newRecordTypeName.length}/50</span>
											</div>
											<Input
												autoFocus
												value={newRecordTypeName}
												onChange={(e) => setNewRecordTypeName(e.target.value)}
												onKeyDown={(e) => {
													if (e.key === 'Enter' && newRecordTypeName.trim() && !isSavingRecordType) {
														handleAddRecordType();
													}
												}}
												placeholder="e.g. Video Call, Client Visit"
												maxLength={50}
												className="h-10 text-sm"
											/>
											{sortedRecordTypes.some(t => (t.Typ || '').trim().toLowerCase() === newRecordTypeName.trim().toLowerCase()) && (
												<p className="text-xs text-red-500">A type with this name already exists.</p>
											)}
										</div>
										<div className="flex gap-2 pt-1">
											<Button
												type="button"
												variant="outline"
												onClick={() => {
													setRecordTypeView('list');
													setNewRecordTypeName('');
												}}
												className="sahi-secondary-button flex-1"
												disabled={isSavingRecordType}
											>
												<X className="h-3.5 w-3.5" /> Close
											</Button>
											<Button
												type="button"
												onClick={handleAddRecordType}
												disabled={!newRecordTypeName.trim() || isSavingRecordType}
												className="sahi-primary-button flex-1"
											>
												{isSavingRecordType ? (
													<Loader2 className="h-3.5 w-3.5 animate-spin" />
												) : (
													<Check className="h-3.5 w-3.5" strokeWidth={3} />
												)}
												Save Type
											</Button>
										</div>
									</div>
								</>
							) : (
								<>
									<div className="flex items-center justify-between px-4 h-16 shrink-0">
										<div className="flex gap-4 items-center">
											<button
												type="button"
												tabIndex={-1}
												onClick={() => setOpenRecordTypeDropdown(false)}
												className="p-0 w-auto h-auto flex-shrink-0 flex justify-center text-gray-500 hover:text-gray-700 cursor-pointer"
											>
												<ArrowLeft className="h-[24px] w-[24px]" />
											</button>
											<p className="text-lg font-semibold text-gray-900">Select Interaction Type</p>
										</div>
										<button
											type="button"
											onClick={() => {
												setNewRecordTypeName('');
												setRecordTypeView('add');
											}}
											className="w-auto h-auto p-0 hover:bg-zinc-100 flex items-center justify-center text-gray-500 hover:text-gray-700 cursor-pointer"
										>
											<Plus className="h-[24px] w-[24px]" />
										</button>
									</div>

									<div className="overflow-y-auto custom-scroll flex-1 px-4 py-1">
										<div className="flex flex-col">
											{sortedRecordTypes.map((item) => {
												const isSel = quickRecordData.recordType === item.Typ;
												return (
													<div
														key={item.TID || item.Typ}
														className={cn(
															'flex items-center justify-between gap-2.5 py-2.5 min-h-[48px] pl-3 sahi-radius px-2 transition-colors cursor-pointer active:bg-gray-50',
															isSel && 'bg-white'
														)}
														onClick={() => {
															setQuickRecordData(prev => ({ ...prev, recordType: item.Typ }));
															setOpenRecordTypeDropdown(false);
														}}
													>
														<span className={cn(
															"flex-1 text-sm font-medium truncate",
															isSel ? "text-gray-900 font-semibold" : "text-text-color"
														)}>
															{item.Typ}
														</span>
														<div className="flex items-center gap-2 shrink-0" onClick={(e) => e.stopPropagation()}>
															{isSel && (
																<CheckCircle className="w-4 h-4 text-sahi-green shrink-0" />
															)}
															<Button
																variant="ghost"
																size="icon"
																className="h-8 w-8 p-0 text-sahi-red hover:bg-sahi-red-light cursor-pointer"
																onClick={() => {
																	setRecordTypeToDelete(item);
																	setDeleteRecordTypeAlertOpen(true);
																}}
															>
																<Trash2 className="h-4 w-4" />
															</Button>
														</div>
													</div>
												);
											})}
										</div>
									</div>

									<div className="px-4 pb-4 pt-2 border-t border-zinc-100 shrink-0">
										<Button
											type="button"
											className="sahi-primary-button w-full"
											onClick={() => {
												setNewRecordTypeName('');
												setRecordTypeView('add');
											}}
										>
											<Plus className="h-4 w-4" /> Add New Type
										</Button>
									</div>
								</>
							)}
						</div>
					</DrawerContent>
				</Drawer>

				{/* Delete Confirmation Alert */}
				{deleteRecordTypeAlertOpen && (
					<AlertBox
						open={deleteRecordTypeAlertOpen}
						onOpenChange={setDeleteRecordTypeAlertOpen}
						title="Are you sure you want to delete this interaction type?"
						description={`Delete "${recordTypeToDelete?.Typ}"? This won't affect interactions that already have this type.`}
						actions={[
							{
								label: "Close",
								variant: "cancel",
								value: 0,
								className: "sahi-secondary-button flex-1 sm:flex-none sm:min-w-[100px]",
								icon: <X className="w-3 h-3" />,
							},
							{
								label: "Delete Type",
								variant: "action",
								value: 1,
								className: "sahi-primary-button flex-1 sm:flex-none sm:min-w-[120px]",
								icon: <Trash2 className="w-3 h-3" />,
							},
						]}
						onAction={(actionValue) => {
							if (actionValue === 1) {
								handleDeleteRecordType();
							} else {
								setDeleteRecordTypeAlertOpen(false);
								setRecordTypeToDelete(null);
							}
						}}
					/>
				)}

			</div>
		</TooltipProvider >
	);
};

export default Connections;